import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      // ===== COMMON / SHARED =====
      cancel: "Cancel",
      clear: "Clear",
      done: "Done",
      submit: "Submit",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      create: "Create",
      search: "Search",
      filter: "Filter",
      export: "Export",
      import: "Import",
      refresh: "Refresh",
      back: "Back",
      next: "Next",
      previous: "Previous",
      yes: "Yes",
      no: "No",
      ok: "OK",
      min: "Min",
      max: "Max",
      success: "Success",
      error: "Error",
      warning: "Warning",
      info: "Info",
      loading: "Loading",
      no_result: "No Result",
      try_searching_again: "Try searching again",
      name: "Name",
      type: "Type",
      status: "Status",
      actions: "Actions",
      description: "Description",
      details: "Details",
      notes: "Notes",
      enabled: "Enabled",
      true: "TRUE",
      false: "FALSE",
      na: "N/A",
      enter: "Enter",
      select_quantity: "Select Quantity",

      // ===== STATS / DATA VISUALIZATION =====
      show_table: "Show Table",
      show_plot: "Show Plot",
      error_loading_statistics: "Failed to load statistics",
      please_adjust_date_range_and_retry:
        "Please adjust the date range if needed and click Search to try again.",
      retry: "Retry",

      // ===== NAVIGATION / HOME =====
      ticket_rails: "Ticket Rails",
      order_management_system: "Order Management System",
      workstations: "Workstations",
      tools: "Tools",
      order_management: "Order Management",
      admin_functions: "Admin Functions",
      admin_dashboard: "Admin Dashboard",
      admin_dashboard_description: "Access all management functions and settings",
      manager_functions: "Manager Functions",
      manager_dashboard: "Manager Dashboard",
      manager_dashboard_description: "Access statistics and QR code management",
      welcome_manager_dashboard: "Welcome to Manager Dashboard",
      manager_dashboard_welcome_description:
        "Select a function from the sidebar or use quick actions below",
      in_store_qr_code_description: "Generate and manage QR codes for in-store ordering",

      // ===== ORDER MANAGEMENT =====
      master_control_station: "Master Control Station",
      completed_orders: "Completed Orders",
      ready_for_pickup: "Ready for Pickup",
      sorted_by_done_time: "Sorted by done time",
      online: "Online",
      in_store: "In-Store",
      others: "Others",
      order_lookup: "Order Lookup",
      order_time: "Order Time",
      start_time: "Start Time",
      done_time: "Done Time",
      paid: "PAID",
      not_paid: "NOT PAID",
      no_results: "No results found",
      error_occurred: "An error occurred",
      created_successfully: "{{item}} created successfully",
      created_successfully_generic: "Created successfully",
      updated_successfully: "{{item}} updated successfully",
      updated_successfully_generic: "Updated successfully",
      saved_successfully: "{{item}} saved successfully",
      saved_successfully_generic: "Saved successfully",
      deleted_successfully: "{{item}} deleted successfully",
      order_date_optional: "Order Date (Optional, default: last 10 orders)",
      input_search_text: "Enter search text",
      back_to_search: "Back to Search",
      search_for: "Searched for:",
      searching: "Searching...",
      virtual_keyboard_hint: "Use the on-screen keyboard to enter your search text.",
      space: "Space",
      backspace: "Backspace",
      phone: "Phone",
      email: "Email",
      immediate: "Immediate",
      within_minutes: "Within {{minutes}} Min",
      more_than_minutes: ">{{minutes}} Min",
      more_than_hours: ">{{hours}} Hrs",
      pickup_time: "Pickup Time",
      customer: "Customer",
      item: "item",
      items: "items",
      unable_to_connect: "Unable to Connect",
      retrying: "Retrying...",
      no_orders: "No orders",
      no_done_orders: "No done orders",
      no_items: "No items",
      start_button: "Start",
      done_button: "Done",
      in_progress: "In Progress",
      not_started: "Not Started",
      pending: "Pending",
      pending_orders: "Pending",
      started: "Started",
      started_orders: "Started",
      completed: "Completed",
      filter_by_item: "Filter by Item",
      order: "Order",
      create_time: "Create Time",
      action: "Action",
      shipping_label: "Shipping Label",
      packing_list: "Packing List",
      quantity: "Qty",
      total_quantity: "Total Qty",
      customer_information: "Customer Information",
      address: "Address",
      pretax_price: "Pretax Price",
      handling_fee: "Handling Fee",
      failed_to_fetch_data: "Failed to fetch data",
      of: "of",
      order_incomplete_warning: "This order seems incomplete. Clover might have an issue.",
      select_reminder_time: "Select reminder time",
      reminder_set: "I will remind you at {{time}}",
      remind_me: "Remind Me",
      reminder_cancelled: "Reminder cancelled",
      cancel_reminder: "Cancel Reminder",
      points_claimed: "Points claimed",
      unable_to_print: "Unable to print",
      unable_to_reprint_labels: "Unable to reprint labels",
      unable_to_print_points: "Unable to print points",
      print_points: "Print Points",
      print: "Print",
      print_order_ticket: "Print Order Ticket",
      reprint_labels: "Reprint Labels",
      print_beverage_labels: "Print Drink Labels",
      print_non_beverage_labels: "Print Non-Drink Labels",
      auto_print_on_start: "Auto-print Labels on Start",
      auto_print_off: "Auto-print Off",
      on: "ON",
      off: "OFF",
      please_try_again_later: "Please try again later",
      unable_to_fetch_tables: "Unable to fetch tables",
      unable_to_add_table: "Unable to add table",
      unable_to_fetch_order_history: "Unable to fetch order history",
      unable_to_fetch_points_history: "Unable to fetch points history",
      sorry_error_occurred: "Sorry, an error occurred!",
      reload: "Reload",
      selected: "Selected",

      // ===== WORKSTATION NAMES =====
      station: "Station",
      workstation_fry: "Fry",
      workstation_grill: "Grill",
      workstation_rice: "Rice",
      workstation_assembly: "Assembly",
      workstation_prep: "Prep",

      // ===== ADMIN FUNCTIONS =====
      edit_menu: "Edit Menu",
      edit_menu_description: "Manage your restaurant menu items",
      edit_customization_options: "Edit Customization Options",
      announcement_settings: "Announcement Settings",
      manage_members: "Manage Customers",
      manage_members_description: "View and manage customer accounts",
      statistics: "Statistics",
      statistics_description: "View performance analytics and insights",
      reports: "Reports",
      in_store_qr_code: "In-Store QR Code",
      shipping_orders: "Shipping Orders",
      shipping_orders_description: "Manage delivery and shipping orders",
      feature_flags: "Feature Flags",
      printer_management: "Printer Management",
      custom_order_page: "Custom Order Page",
      menu_management: "Menu Management",
      large_volume_management: "Group Order Management",
      members_management: "Customer Management",
      orders_management: "Orders Management",
      data_analytics: "Data & Analytics",
      settings: "Settings",
      back_to_home: "Back to Home",
      welcome_admin_dashboard: "Welcome to Admin Dashboard",
      admin_dashboard_welcome_description:
        "Select a function from the sidebar or use quick actions below",
      quick_actions: "Quick Actions",
      all_functions: "All Functions",
      search_by_name: "Search by Name",

      // ===== LOGIN =====
      login: "Login",
      account: "Account",
      password: "Password",
      please_enter_account: "Please enter account",
      please_enter_password: "Please enter password",
      required_to_login_with_admin_account: "Required to login with admin account",
      no_restaurants_for_account: "No restaurants for this account",
      failed_to_login: "Failed to login",

      // ===== TRID CONVERTER =====
      trid_converter_title: "TRID Converter",
      trid_converter_description: "Convert between UUIDs and TicketRails IDs.",
      trid_converter_uuid_to_trid: "UUID to TRID",
      trid_converter_trid_to_uuid: "TRID to UUID",
      trid_converter_uuid: "UUID",
      trid_converter_trid: "TRID",
      trid_converter_tag: "Tag",
      trid_converter_uuid_placeholder: "600f2814-c7d7-438c-b419-d813b15966aa",
      trid_converter_trid_placeholder: "its_YA8oFMfXQ4y0GdgTsVlmqg",
      trid_converter_tag_placeholder: "its",
      trid_converter_result_placeholder: "The converted value will appear here",
      trid_converter_tag_help: "Enter the three-letter resource tag.",
      trid_converter_invalid_uuid: "Enter a valid UUID.",
      trid_converter_invalid_tag: "The tag must contain exactly three lowercase letters.",
      trid_converter_invalid_trid: "Enter a valid TRID.",
      trid_converter_invalid_trid_payload: "The TRID does not contain a valid UUID.",
      trid_converter_trid_result: "Converted TRID",
      trid_converter_uuid_result: "Converted UUID",
      trid_converter_tag_result: "TRID tag",
      trid_converter_copy_trid: "Copy TRID",
      trid_converter_copy_uuid: "Copy UUID",
      trid_converter_copied: "Copied",
      trid_converter_local_only: "All conversions happen locally in your browser.",

      // ===== RESTAURANT SELECTION =====
      select_restaurant: "Select Restaurant",
      select_restaurant_description: "Choose which restaurant to manage",
      switch_restaurant: "Switch Restaurant",
      select: "Select",

      // ===== ITEM MODIFICATION SCHEMA =====
      add_customization_option: "Add Customization Option",
      option_name: "Option Name",
      please_enter_option_name: "Please enter option name",
      allow_multiple_selection: "Allow Multiple Selection",
      optional: "Optional",
      option_list: "Option List",
      add_option: "Add Option",
      price_adjustment: "Price Adjustment",
      default: "Default",
      edit_customization_option: "Edit Customization Option",
      delete_customization_option_confirm: "Delete customization option?",
      delete_customization_option_description:
        "This action cannot be undone. Items using this option will be affected.",

      // ===== MENU EDITOR =====
      menu_item_name: "Menu Item Name",
      receipt_name: "Receipt Name",
      kitchen_chinese_name: "Kitchen Chinese Name",
      kitchen_spanish_name: "Kitchen Spanish Name",
      kitchen_english_name: "Kitchen English Name",
      key_example: "Key (e.g. R3, A4)",
      price: "Price",
      points: "Points",
      points_config: "Points Settings",
      failed_to_fetch_points_config: "Failed to fetch points settings",
      failed_to_update_points_config: "Failed to update points settings",
      use_automatic_redeem_rate: "Use Automatic Redeem Rate",
      use_automatic_redeem_rate_description:
        "When on, items with no points value set use this rate (based on price) to become redeemable. Items with a points value keep it.",
      redeem_rate: "Redeem Rate",
      redeem_rate_description:
        "Default points per $1, used only for items with no points value set. Price is rounded up to the next dollar.",
      redeem_rate_required_when_enabled:
        "A redeem rate is required when automatic redeem rate is on.",
      redeem_rate_must_be_positive: "Redeem rate must be greater than 0.",
      points_per_dollar: "points / $",
      redeem_rate_preview: "A $10 item with no points set costs {{points}} points to redeem.",
      points_redeem_rate_fallback:
        "Leave blank to use the redeem rate ({{points}} pts for this price).",
      wait_config: "Pickup Wait Settings",
      failed_to_fetch_wait_config: "Failed to fetch pickup wait settings",
      failed_to_update_wait_config: "Failed to update pickup wait settings",
      wait_config_intro:
        "Pickup wait quotes grow with kitchen load, measured in prep points. Each item contributes the prep weight of the workstations that prepare it (set on the workstation page).",
      base_wait_minutes: "Base Wait",
      base_wait_minutes_description: "Minimum wait quoted when the kitchen is idle.",
      points_per_step: "Load per Extra Step",
      points_per_step_description:
        "Kitchen load (in prep points) that adds one step of extra wait.",
      step_minutes: "Step Size",
      step_minutes_description: "Extra minutes added per full load step.",
      max_wait_minutes: "Maximum Wait",
      max_wait_minutes_description: "Upper cap on the quoted wait, regardless of kitchen load.",
      large_order_points: "Large Order Threshold",
      large_order_points_description:
        "Orders above this many prep points are treated as large: they see the entire kitchen backlog, and they do not delay small orders.",
      minutes: "min",
      load_points: "prep points",
      wait_config_minutes_range: "Must be between 1 and {{max}} minutes.",
      wait_config_step_minutes_range: "Must be between 0 and {{max}} minutes.",
      wait_config_points_range: "Must be between 1 and {{max}} points.",
      max_wait_must_be_gte_base: "Maximum wait cannot be less than the base wait.",
      wait_config_summary:
        "Quotes start at {{base}} min and grow by {{step}} min for every {{pointsPerStep}} points of kitchen load, up to {{max}} min. Orders above {{largeOrderPoints}} points are treated as large orders.",
      prep_weight: "Prep Weight",
      prep_weight_description:
        "Kitchen load points added per item action at this station (e.g. fry = 3, rice = 1, assembly = 0). Used for the load-aware pickup wait estimate.",
      prep_weight_unit: "points / action",
      prep_weight_range: "Prep weight must be between 0 and {{max}}.",
      failed_to_update_prep_weight: "Failed to update prep weight",
      tax_free: "Tax Free",
      shippable: "Shippable",
      weight_grams: "Weight (grams)",
      print_label: "Print Label",
      sold_out: "Sold Out",
      featured: "Featured",
      actions_workstation: "Actions (Workstation)",
      modifications_customization: "Modifications (Customization)",
      upload_image: "Upload Image",
      saving: "Saving...",
      name_is_required: "Name is required.",
      price_is_required: "Price is required.",
      weight_is_required_for_shippable: "Weight is required for shippable item.",
      select_menu_type: "Select Menu Type",
      dine_in_pickup: "Dine In / Pickup",
      group_order: "Group Order",
      notification_time_minutes: "Notification Time (minutes)",
      limited_quantity: "Limited Quantity",
      quantity_limit: "Quantity Limit",
      quantity_limit_help: "Maximum total supply. Leave blank for unlimited.",
      quantity_limit_placeholder: "Unlimited",
      per_order_quantity_limit: "Per-Order Quantity Limit",
      per_order_quantity_limit_help: "Maximum quantity per order. Leave blank for unlimited.",
      per_order_quantity_limit_placeholder: "Unlimited",
      limited_quantity_inventory: "Limited Quantity Inventory",
      consumption_trend: "Consumption Trend",
      no_limited_quantity_items: "No limited-quantity items configured.",
      select_item: "Select item",
      select_an_item_to_view_trend: "Select an item to view its consumption trend.",
      no_trend_data: "No consumption data in the selected range.",
      consumed: "Consumed",
      reserved: "Reserved",
      remaining: "Remaining",
      delete_menu_item_confirm: "Are you sure you want to delete {{name}}?",
      delete_menu_item_description: "This action cannot be undone.",
      create_item: "Create Item",
      image: "Image",
      bulk_update_success: "Updated {{count}} item(s) successfully!",
      bulk_update_partial_failure: "{{success}} of {{total}} items updated. {{failed}} failed.",

      // ===== MEMBERS =====
      email_or_phone: "Email or Phone",
      member_since: "Member Since",
      order_history: "Order History",
      points_history: "Points History",
      adjust_points: "Adjust Points",
      search_member: "Search Member",
      member_information: "Member Information",
      member_not_found: "Member not found",
      unable_to_search_member: "Unable to search member",
      email_or_phone_is_required: "Email or phone is required.",
      points_is_required: "Points is required.",
      expiration: "Expiration",
      expiration_date_required_for_credits: "Expiration date is required for adding credits.",
      manually_added_by_restaurant: "Manually added by restaurant",
      added_points_successfully: "Added {{delta}} points successfully!",

      // ===== ANNOUNCEMENTS =====
      title: "Title",
      content: "Content",
      create_new_announcement: "Create New Announcement",
      current_announcements: "Current Announcements",
      no_announcements: "No announcements yet",
      system_shutdown_control: "System Shutdown Control",
      title_is_required: "Title is required.",
      announcement_type_is_required: "Announcement type is required.",
      added_new_announcement_successfully: "Added new announcement successfully!",
      open_restaurant: "Open Restaurant",
      shutdown_restaurant: "Shutdown Restaurant",
      reopen: "Reopen",
      temporarily_closed: "Temporarily Closed",
      are_you_sure_reopen: "Are you sure you want to reopen the restaurant?",
      are_you_sure_shutdown: "Are you sure you want to shut down the restaurant?",
      restaurant_shutdown_successfully: "Restaurant shut down successfully!",
      restaurant_reopened_successfully: "Restaurant reopened successfully!",
      temporary_closure: "Temporary Closure",
      sorry_temporarily_closed: "Sorry! We are temporarily closed! Please check back later.",

      // ===== FEATURE FLAGS =====
      flag_name: "Flag Name",
      enabled_is_required: "Enabled is required.",
      updated_feature_flag_successfully: "Updated feature flag successfully!",
      failed_to_save_feature_flag: "Failed to save feature flag",
      failed_to_fetch_flags: "Failed to fetch flags",
      update_flag: "Update Flag",
      current_flags: "Current Flags",
      no_flags_available: "No feature flags available",
      flags: "flags",

      // ===== PRINTER MANAGEMENT =====
      saved_printers: "Saved Printers",
      add_a_printer: "Add a Printer",
      select_printer_type: "Select Printer Type",
      manage_connected_printers: "Manage your connected printers",
      no_saved_printers: "No saved printers yet",
      no_available_printers: "No available printers",
      make_sure_printer_plugged_in: "Make sure the printer is powered on and connected.",
      select_type_for_printer: "Select the type for this printer",
      failed_to_load_connected_printers: "Failed to load connected printers.",
      printer_added_successfully: "Printer added successfully.",
      failed_to_add_printer: "Failed to add printer. It might already be connected.",
      printer_deleted_successfully: "Printer deleted successfully.",
      failed_to_delete_printer: "Failed to delete printer.",
      serial: "Serial",
      vendor_id: "Vendor ID",
      product_id: "Product ID",
      add_a_usb_printer: "Add a USB printer",
      add_a_network_printer: "Add a network printer",
      scan_for_new_printers: "Scan for new printers",
      scanning_for_printers: "Scanning for new printers",
      this_will_take_around_10_seconds: "This will take about 10 seconds",
      printer_scan_complete: "Printer scan complete",
      print_test_page: "Print test page",
      test_page_printed_successfully: "Test page printed successfully.",
      failed_to_print_test_page: "Failed to print test page.",
      only_one_printer_per_type: "Only one printer can be saved per printer type.",
      printer_type_already_added:
        "A {{type}} printer is already saved. Remove the existing {{type}} printer before adding a new one.",
      printer_type_already_added_short: "already added",
      all_printer_types_already_added:
        "A printer is already saved for every printer type. Remove one before adding another.",

      // ===== WORKSTATION =====
      clear_all_items: "Clear all items?",

      // ===== QR CODES =====
      qr_code_management: "QR Code Management",
      table_number: "Table Number",
      generate_qr_code: "Generate QR Code",
      create_new_qr_code: "Create New QR Code",
      current_qr_codes: "Current QR Codes",
      no_qr_codes_message: "No QR codes yet. Create one to get started!",
      total_qr_codes: "Total {{total}} QR codes",

      // ===== SHIPPING =====
      shipping_management: "Shipping Management",
      shipping_orders_management: "Shipping Orders Management",
      tracking_number: "Tracking Number",
      shipping_address: "Shipping Address",
      order_status: "Order Status",

      // ===== STATS & REPORTS =====
      view_statistics: "View Statistics",
      generate_report: "Generate Report",
      date_range: "Date Range",
      start_date: "Start Date",
      end_date: "End Date",
      total_orders: "Total Orders",
      total_revenue: "Total Revenue",
      average_order_value: "Average Order Value",
      select_month: "Select Month",
      order_report: "Order Report",
      current_month_to_date: "Current month to date",

      // ===== CAMPAIGNS =====
      campaign_name: "Campaign Name",
      campaigns: "Campaigns",
      create_campaign: "Create Campaign",
      copy_campaign: "Copy Campaign",
      campaign_copy_prefix: "Copy of ",
      campaign_status: "Status",
      campaign_status_past: "Past",
      campaign_status_active: "Active",
      campaign_status_scheduled: "Scheduled",
      campaigns_load_failed: "Failed to load campaigns",
      campaign: "Campaign",
      campaign_pending: "{{name}} - pending",
      campaign_done: "{{name}} - done",
      no_campaigns: "No campaigns found",
      campaign_export_paid_orders: "Export Paid Orders",
      campaign_export_failed: "Failed to export paid orders",
      campaign_no_paid_orders: "This campaign has no paid orders yet",
      campaign_summary_load_failed: "Failed to load campaign summary",
      campaign_paid_orders: "Paid Orders",
      campaign_item_name: "Item",
      campaign_item_modifications: "Modifications",
      not_available: "N/A",
      campaign_type: "Campaign Type",
      campaign_basic_information: "Campaign Basic Information",
      schedule_settings: "Schedule Settings",
      select_menu_items: "Select Menu Items",
      slug: "Slug",
      ticket_prefix: "Ticket Prefix",
      order_deadline_date: "Order Deadline Date",
      order_deadline_time: "Order Deadline Time",
      fulfillment_start_date: "Fulfillment Start Date",
      fulfillment_end_date: "Fulfillment End Date",
      fulfillment_date_range: "Fulfillment Date Range",
      fulfillment_time_start: "Fulfillment Time Start",
      fulfillment_time_end: "Fulfillment Time End",
      is_batch_delivery: "Is Batch Delivery",
      save_campaign: "Save Campaign",
      please_input_name: "Please input the name",
      please_input_slug: "Please input the slug",
      please_input_ticket_prefix: "Please input the ticket prefix",
      please_select_date: "Please select a date",
      please_select_time: "Please select a time",
      total_items_count: "Total {{total}} items",

      // ===== FORM VALIDATION =====
      this_field_is_required: "This field is required",
      please_enter_valid_email: "Please enter a valid email",
      please_enter_valid_phone: "Please enter a valid phone number",

      // ===== TOOLTIPS =====
      tooltip_back: "Back to Home",
      tooltip_printer: "Printer Management",
      tooltip_refresh: "Refresh Page",
      tooltip_logout: "Logout",

      // ===== HEADER MENU =====
      language: "Language",
      logout: "Logout",
      choose_your_language: "Choose Your Language",
      language_preference_saved: "Your language preference will be saved automatically",

      // ===== INTEGRATIONS =====
      integrations: "Integrations",
      square_integrations: "Square Integrations",
      add_square_integration: "Add Square Integration",
      current_integrations: "Current Integrations",
      failed_to_fetch_integrations: "Failed to fetch integrations",
      failed_to_create_integration: "Failed to create integration",
      failed_to_delete_integration: "Failed to delete integration",
      delete_integration_confirm: "Are you sure you want to delete this integration?",
      delete_integration_description: "This action cannot be undone.",
      no_integrations_available: "No integrations available",
      access_token: "Access Token",
      access_token_required: "Access token is required",
      enter_access_token: "Enter access token",
      location_id: "Location ID",
      location_id_required: "Location ID is required",
      enter_location_id: "Enter location ID",
      tax_percentage: "Tax Percentage",
      tax_percentage_tooltip: "The tax percentage to apply to online orders.",
      enter_tax_percentage: "Enter tax percentage (e.g. 9.25)",
      tax_percentage_required: "Tax percentage is required when using for online payment",
      tax_percentage_invalid_format: "Please enter a valid number with up to 5 decimal places",
      edit_tax_percentage: "Edit Tax %",
      enter_tax_percentage_6_decimals:
        "Enter a positive decimal number with up to 6 decimal places.",
      tax_percentage_invalid_format_6_decimals:
        "Please enter a valid positive number with up to 6 decimal places",
      tax_percentage_must_be_positive: "Tax percentage must be a positive number",
      failed_to_update_tax_percentage: "Failed to update tax percentage",
      use_for_online_payment: "Use for Online Payment",
      create_integration: "Create Integration",
      merchant_id: "Merchant ID",

      // ===== WORKSTATION SCHEMAS =====
      workstation_schemas: "Workstations",
      workstation_schema: "Workstation",
      add_workstation_schema: "Add Workstation",
      edit_workstation_schema: "Edit Workstation",
      current_workstation_schemas: "Current Workstations",
      no_workstation_schemas_available: "No workstation available",
      failed_to_fetch_workstation_schemas: "Failed to fetch workstations",
      failed_to_create_workstation_schema: "Failed to create workstation",
      failed_to_update_workstation_schema: "Failed to update workstation",
      failed_to_delete_workstation_schema: "Failed to delete workstation",
      delete_workstation_schema_confirm: "Are you sure you want to delete this workstation?",
      delete_workstation_schema_description: "This action cannot be undone.",
      enter_workstation_name: "Enter workstation name",

      // ===== ITEM SCHEMA GROUPS =====
      item_schema_groups: "Item Groups",
      item_schema_group: "Item Group",
      add_item_schema_group: "Add Item Group",
      edit_item_schema_group: "Edit Item Group",
      current_item_schema_groups: "Current Item Groups",
      no_item_schema_groups_available: "No item groups available",
      failed_to_fetch_item_schema_groups: "Failed to fetch item groups",
      failed_to_create_item_schema_group: "Failed to create item group",
      failed_to_update_item_schema_group: "Failed to update item group",
      failed_to_delete_item_schema_group: "Failed to delete item group",
      delete_item_schema_group_confirm: "Are you sure you want to delete this item group?",
      delete_item_schema_group_description: "This action cannot be undone.",
      enter_group_name: "Enter item group name",
      menu_type: "Menu Type",
      menu_type_is_required: "Menu type is required",
      sequence: "Sequence",
      sequence_is_required: "Sequence is required",
      enter_sequence: "Enter sequence number",

      // ===== RESTAURANT PUBLIC INFO =====
      restaurant_public_info: "Restaurant Information",
      failed_to_fetch_restaurant_public_info: "Failed to fetch restaurant information",
      failed_to_update_restaurant_public_info: "Failed to update restaurant information",
      enter_address: "Enter address",
      business_hours: "Business Hours",
      open_time: "Open Time",
      close_time: "Close Time",
      select_open_time: "Select open time",
      select_close_time: "Select close time",
      social_media_links: "Social Media Links",
      instagram_url: "Instagram URL",
      google_url: "Google URL",
      yelp_url: "Yelp URL",
      facebook_url: "Facebook URL",
      enter_instagram_url: "Enter Instagram URL",
      enter_google_url: "Enter Google URL",
      enter_yelp_url: "Enter Yelp URL",
      enter_facebook_url: "Enter Facebook URL",
      ordering_links: "Ordering Links",
      order_url: "Order URL",
      order_url_help: "URL of the order website when managed by us. Leave blank if not applicable.",
      enter_order_url: "Enter order URL",
      delivery_url: "Delivery URL",
      delivery_url_help:
        "Third-party delivery ordering URL (e.g. DoorDash). Leave blank if delivery is not offered.",
      enter_delivery_url: "Enter delivery URL",
      public_listing: "Public Listing",
      listed: "Listed",
      listed_help:
        "Whether this restaurant appears in the public locations listing on the order site.",
      coming_soon: "Coming Soon",
      coming_soon_help:
        'A listed location that is not yet open for business: shown on the order site with its info and a "Coming Soon" treatment, but not orderable.',
      coming_soon_requires_listed: "The location must be listed to mark it as coming soon.",
      default_tip_percentages: "Default Tip Percentages",
      tip_option_1: "Tip Option 1",
      tip_option_2: "Tip Option 2",
      tip_option_3: "Tip Option 3",

      // ===== LARGE VOLUME DELIVERY =====
      large_volume_delivery: "Group Order Delivery",
      delivery_zones: "Delivery Zones",
      delivery_zone: "Delivery Zone",
      add_delivery_zone: "Add Delivery Zone",
      edit_delivery_zone: "Edit Delivery Zone",
      current_delivery_zones: "Current Delivery Zones",
      no_delivery_zones_available: "No delivery zones available",
      failed_to_fetch_delivery_zones: "Failed to fetch delivery zones",
      failed_to_create_delivery_zone: "Failed to create delivery zone",
      failed_to_update_delivery_zone: "Failed to update delivery zone",
      failed_to_delete_delivery_zone: "Failed to delete delivery zone",
      delete_delivery_zone_confirm: "Are you sure you want to delete this delivery zone?",
      delete_delivery_zone_description: "This action cannot be undone.",
      zone_name: "Zone Name",
      enter_zone_name: "Enter zone name",
      minimum_pretax_price: "Minimum Pretax Price",
      minimum_pretax_price_is_required: "Minimum pretax price is required",
      enter_minimum_pretax_price: "Enter minimum pretax price",
      delivery_fee: "Delivery Fee",
      delivery_fee_is_required: "Delivery fee is required",
      enter_delivery_fee: "Enter delivery fee",
      free_delivery_threshold: "Free Delivery Threshold",
      free_delivery_threshold_is_required: "Free delivery threshold is required",
      enter_free_delivery_threshold: "Enter free delivery threshold",
      postal_codes: "Postal Codes",
      postal_code: "Postal Code",
      add_postal_code: "Add Postal Code",
      edit_postal_code: "Edit Postal Code",
      current_postal_codes: "Current Postal Codes",
      no_postal_codes_available: "No postal codes available",
      failed_to_fetch_postal_codes: "Failed to fetch postal codes",
      failed_to_create_postal_code: "Failed to create postal code",
      failed_to_update_postal_code: "Failed to update postal code",
      failed_to_delete_postal_code: "Failed to delete postal code",
      delete_postal_code_confirm: "Are you sure you want to delete this postal code?",
      delete_postal_code_description: "This action cannot be undone.",
      postal_code_is_required: "Postal code is required",
      enter_postal_code: "Enter postal code",
      delivery_zone_is_required: "Delivery zone is required",
      select_delivery_zone: "Select delivery zone",
      create_delivery_zone_first: "Please create a delivery zone first",

      // ===== LARGE VOLUME PICKUP CONFIG =====
      large_volume_pickup_config: "Group Order Pickup",
      no_large_volume_pickup_config_available: "No group order pickup config available",
      failed_to_fetch_large_volume_pickup_config: "Failed to fetch group order pickup config",
      failed_to_create_large_volume_pickup_config: "Failed to create group order pickup config",
      failed_to_update_large_volume_pickup_config: "Failed to update group order pickup config",
      failed_to_delete_large_volume_pickup_config: "Failed to delete group order pickup config",

      promo_codes: "Promo Codes",
      promo_code: "Promo Code",
      create_promo_code: "Create Promo Code",
      no_promo_codes_available: "No promo codes available",
      failed_to_fetch_promo_codes: "Failed to fetch promo codes",
      failed_to_create_promo_code: "Failed to create promo code",
      failed_to_update_promo_code: "Failed to update promo code",
      failed_to_fetch_item_schemas: "Failed to fetch item schemas",
      promo_slug: "Slug",
      slug_is_required: "Slug is required",
      slug_max_length: "Slug must be at most 100 characters",
      slug_placeholder: "e.g. SAVE10",
      promo_description: "Description",
      description_placeholder: "Optional admin-facing description",
      promo_discount: "Discount",
      discount_type: "Discount Type",
      percent_of_order_total: "Percent of Order Total",
      fixed_amount: "Fixed Amount",
      discount_percent: "Discount Percent",
      discount_amount: "Discount Amount",
      discount_value_is_required: "Discount value is required",
      discount_percent_range: "Percent must be between 1 and 100",
      discount_amount_positive: "Amount must be positive",
      promo_expire_time: "Expire Time",
      expire_time_is_required: "Expire time is required",
      edit_expire_time: "Edit Expire Time",
      expired: "Expired",
      promo_conditions: "Conditions",
      promo_min_spend: "Min Spend",
      min_spend_conditions: "Min Spend Conditions",
      min_spend_is_required: "Min spend is required",
      add_min_spend_condition: "Add Min Spend Condition",
      item_conditions: "Item Conditions",
      promo_item: "Item",
      item_is_required: "Item is required",
      quantity_is_required: "Quantity is required",
      promo_select_item: "Select an item",
      add_item_condition: "Add Item Condition",
      promo_code_condition_required_notice:
        "At least one condition (min spend or item) is required.",
      counts_towards_min_spend: "Counts towards min spend",
      excludes_from_min_spend: "Excludes from min spend",
      promo_item_excludes_min_spend: "excludes min spend",
      promo_item_min_spend_help:
        "When off, this item's required quantity does not count towards the minimum spend.",

      // ===== PREPAID CARDS =====
      view: "View",
      publish: "Publish",
      archive: "Archive",
      close: "Close",
      exclusive_end: "exclusive",
      day_sun: "Sunday",
      day_mon: "Monday",
      day_tue: "Tuesday",
      day_wed: "Wednesday",
      day_thu: "Thursday",
      day_fri: "Friday",
      day_sat: "Saturday",
      day_sun_abbr: "Sun",
      day_mon_abbr: "Mon",
      day_tue_abbr: "Tue",
      day_wed_abbr: "Wed",
      day_thu_abbr: "Thu",
      day_fri_abbr: "Fri",
      day_sat_abbr: "Sat",

      prepaid_cards: "Prepaid Cards",
      prepaid_card: "Prepaid Card",
      prepaid_card_stats: "Prepaid Card Stats",
      prepaid_card_create: "Create Prepaid Card",
      prepaid_card_edit: "Edit Prepaid Card",
      prepaid_card_view: "View Prepaid Card",
      prepaid_card_none_available: "No prepaid cards available",
      failed_to_fetch_prepaid_cards: "Failed to fetch prepaid cards",
      failed_to_create_prepaid_card: "Failed to create prepaid card",
      failed_to_update_prepaid_card: "Failed to update prepaid card",
      failed_to_publish_prepaid_card: "Failed to publish prepaid card",
      failed_to_archive_prepaid_card: "Failed to archive prepaid card",
      failed_to_delete_prepaid_card: "Failed to delete prepaid card",
      prepaid_card_published_successfully: "Prepaid card published successfully",
      prepaid_card_archived_successfully: "Prepaid card archived successfully",
      prepaid_card_deleted_successfully: "Prepaid card deleted successfully",
      prepaid_card_price: "Price",
      prepaid_card_price_is_required: "Price is required",
      prepaid_card_price_positive: "Price must be positive",
      prepaid_card_redeem_count: "Redeem Count",
      prepaid_card_redeem_count_is_required: "Redeem count is required",
      prepaid_card_redeem_count_positive: "Redeem count must be positive",
      prepaid_card_redeems_lowercase: "redeems",
      prepaid_card_tax_free: "Tax Free",
      prepaid_card_supported_items: "Supported Items",
      prepaid_card_supported_items_required: "At least one supported item is required",
      prepaid_card_select_items: "Select supported items",
      prepaid_card_redeem_window: "Redemption Window",
      prepaid_card_redeem_window_required: "Redemption window is required",
      prepaid_card_redeem_window_help: "The end date is exclusive.",
      prepaid_card_redeem_days: "Redeemable Days",
      prepaid_card_redeem_days_required: "At least one redeemable day is required",
      prepaid_card_purchase_window: "Purchase Window",
      prepaid_card_purchase_window_required: "Purchase window is required",
      prepaid_card_image: "Image",
      prepaid_card_name_placeholder: "e.g. 10 Lunch Bentos",
      prepaid_card_published_readonly_notice:
        "This prepaid card is published and can no longer be edited. You can still archive it to stop new sales.",
      prepaid_card_publish_confirm_title: 'Publish "{{name}}"?',
      prepaid_card_publish_warning:
        "Once published, this prepaid card can no longer be changed — price, redeem count, supported items, and both date windows are final, because customers will be buying it under these terms. You can still archive it to stop new sales.",
      prepaid_card_archive_confirm_title: 'Archive "{{name}}"?',
      prepaid_card_archive_confirm_body:
        "Archiving hides this card from new sales. Cards already purchased keep working.",
      prepaid_card_delete_confirm_title: 'Delete "{{name}}"?',
      prepaid_card_delete_confirm_body: "This draft prepaid card will be permanently deleted.",
      prepaid_card_delete_disabled_sold: "Cannot delete: this card has already sold cards",
      prepaid_card_cards_sold: "Cards Sold",
      prepaid_card_cards_pending_payment: "Pending Payment",
      prepaid_card_gross_revenue: "Gross Revenue",
      prepaid_card_counts_sold: "Counts Sold",
      prepaid_card_counts_redeemed: "Counts Redeemed",
      prepaid_card_counts_reserved: "Counts Reserved",
      prepaid_card_outstanding_redeems: "Outstanding Redeems",
      prepaid_card_expired_redeems: "Expired",
      prepaid_card_liability: "Liability",
      prepaid_card_total_outstanding_redeems: "Total Outstanding Redeems",
      prepaid_card_total_outstanding_liability: "Total Outstanding Liability",
      prepaid_card_no_stats_available: "No prepaid card stats available",
      prepaid_card_supported_items_unavailable: "Supported items unavailable",
      prepaid_card_status_draft: "Draft",
      prepaid_card_status_scheduled: "Scheduled",
      prepaid_card_status_live: "Live",
      prepaid_card_status_ended: "Ended",
      prepaid_card_status_archived: "Archived",

      // ===== POINT GIFT CARDS =====
      point_gift_cards: "Point Gift Cards",
      point_gift_card: "Point Gift Card",
      add_point_gift_card: "Add Point Gift Card",
      current_gift_cards: "Current Gift Cards",
      no_gift_cards_available: "No gift cards available",
      no_gift_cards_match_search: "No gift cards match your search",
      failed_to_fetch_gift_cards: "Failed to fetch gift cards",
      failed_to_create_gift_card: "Failed to create gift card",
      failed_to_delete_gift_card: "Failed to delete gift card",
      failed_to_download_qr_code: "Failed to download QR code",
      download_qr_code: "Download QR code (PNG)",
      download_sign: "Download printable sign (PDF)",
      download_all_signs: "Download all signs",
      download_selected_signs: "Download selected ({{count}})",
      failed_to_download_sign: "Failed to download sign",
      order_type: "Order Type",
      dine_in: "Dine In",
      to_go: "To Go",
      order_type_is_required: "Order type is required.",
      added_new_table_successfully: "Added new table successfully!",
      delete_table_confirm: "Delete {{name}}?",
      preview_sign: "Preview sign",
      delete_gift_card_confirm: "Are you sure you want to delete this gift card?",
      delete_gift_card_description: "This action cannot be undone.",
      cannot_delete_claimed_card: "Cannot delete a claimed gift card",
      create_gift_card: "Create Gift Card",
      gift_cards: "gift cards",
      description_is_required: "Description is required",
      enter_description: "Enter description",
      amount: "Amount",
      amount_is_required: "Amount is required",
      amount_must_be_greater_than_zero: "Amount must be greater than 0",
      enter_amount: "Enter amount",
      expiry_date: "Expiry Date",
      expiry_date_tooltip: "Optional. Leave empty for no expiration.",
      select_expiry_date: "Select expiry date",
      claimed: "Claimed",
      qr_code: "QR Code",
      search_by_amount_or_description: "Search by amount or description",

      // ===== COMMON FORM =====
      total: "Total",
      reset: "Reset",

      // ===== USER MANAGEMENT =====
      user_management: "User Management",
      add_user: "Add User",
      edit_roles: "Edit Roles",
      reset_password: "Reset Password",
      change_password: "Change Password",
      send_invite: "Send Invite",
      remove_user: "Remove User",
      no_users_available: "No users available",
      failed_to_fetch_users: "Failed to fetch users",
      failed_to_create_user: "Failed to create user",
      failed_to_update_roles: "Failed to update roles",
      failed_to_reset_password: "Failed to reset password",
      failed_to_change_password: "Failed to change password",
      failed_to_remove_user: "Failed to remove user",
      failed_to_send_invite: "Failed to send invite",
      user_created_successfully: "User created successfully",
      user_created_send_invite_hint: "User created. Use 'Send Invite' to set up their password.",
      user_added_to_restaurant: "User added to restaurant",
      user_removed_successfully: "User removed successfully",
      roles_updated_successfully: "Roles updated successfully",
      password_reset_successfully: "Password reset successfully",
      password_changed_successfully: "Password changed successfully",
      password_changed_please_login: "Password changed successfully. Please log in again.",
      invite_sent_successfully: "Invite sent successfully",
      remove_user_confirm: "Remove this user?",
      remove_user_description: "The user will no longer have access to this restaurant.",
      cannot_remove_yourself: "You cannot remove yourself",
      cannot_modify_admin: "Cannot modify another admin",
      you: "You",
      roles: "Roles",
      role: "Role",
      role_admin: "Admin",
      role_manager: "Manager",
      role_regular_user: "Regular User (no special access)",
      roles_help: "Leave empty for regular user access only",
      please_select_roles: "Please select at least one role",
      please_enter_email: "Please enter email",
      enter_email: "Enter email",
      user_exists_info: "User already exists",
      user_exists_description:
        "This user will be added to the restaurant with their existing credentials.",
      password_option: "Password Option",
      set_password_now: "Set password now",
      send_invite_email: "Send invite email",
      enter_password: "Enter password",
      password_min_length: "Password must be at least 6 characters",
      editing_roles_for: "Editing roles for:",
      resetting_password_for: "Resetting password for:",
      new_password: "New Password",
      confirm_password: "Confirm Password",
      please_enter_new_password: "Please enter new password",
      enter_new_password: "Enter new password",
      please_confirm_password: "Please confirm password",
      confirm_new_password: "Confirm new password",
      passwords_do_not_match: "Passwords do not match",
      current_password: "Current Password",
      please_enter_current_password: "Please enter current password",
      enter_current_password: "Enter current password",

      // Accept Invite Page
      set_your_password: "Set Your Password",
      set_password_description: "Create a password to complete your account setup.",
      set_password: "Set Password",
      password_set_successfully: "Password Set Successfully",
      you_can_now_login: "Your password has been set. You can now log in with your credentials.",
      go_to_login: "Go to Login",
      invalid_invite_link: "Invalid Invite Link",
      invalid_invite_link_description:
        "This invite link is invalid or has expired. Please contact your administrator for a new invite.",
      failed_to_accept_invite: "Failed to accept invite. Please try again.",
      confirm_your_password: "Confirm your password",

      // ===== COMBOS =====
      move_up: "Move up",
      move_down: "Move down",
      remove: "Remove",
      combo_addons: "Combo Add-ons",
      combo_addons_description:
        "Reusable add-ons (e.g. drinks, sides) that combos offer. Items are grouped into price tiers; the tier price replaces the item's regular price inside a combo.",
      combo_add: "Add combo",
      combo_badge: "Combo",
      combo_create: "Create combo",
      combo_name: "Combo name",
      combo_basic_info: "Combo details",
      combo_chinese_name: "Chinese name",
      combo_spanish_name: "Spanish name",
      combo_english_name: "English name",
      combo_entrees: "Entrees",
      combo_entrees_help: "The customer picks one entree, at its regular price.",
      combo_needs_entree: "Add at least one entree",
      combo_attach_addon: "Attach an add-on",
      combo_create_new_addon: "Create new add-on",
      combo_no_addons: "No add-ons",
      combo_no_addons_yet: "No add-ons attached. Customers will only pick an entree.",
      combo_required: "Required",
      combo_required_for: "{{name}} required",
      combo_tiers_count: "Tiers ({{count}})",
      combo_n_pts: "{{points}} pts",
      combo_pts: "pts",
      combo_preview: "Preview",
      combo_preview_needs_entree: "Add an entree to see the price.",
      combo_starting_price: "Starting price",
      combo_from_price: "From {{price}}",
      combo_price_range: "Price range: {{min}} – {{max}}",
      combo_price_range_help: "Cheapest to most expensive combination, without options.",
      combo_from_points: "From {{points}} pts",
      combo_not_redeemable_with_points: "Not redeemable with points",
      combo_partly_redeemable_with_points: "Some choices can't be redeemed with points",
      combo_reason_entree_no_points: "{{name}} has no points",
      combo_reason_tier_no_points: "{{addon}} ({{tier}}) has no points",
      combo_failed_to_load: "Failed to load combos",
      combo_failed_to_save: "Failed to save combo",
      combo_delete_confirm: "Delete combo {{name}}?",
      combo_item_not_on_menu: "Item not on this menu",
      combo_search_items: "Search items to add",
      combo_items_selected: "{{count}} selected",
      combo_no_items_found: "No items found",
      combo_create_addon: "Create add-on",
      combo_edit_addon: "Edit add-on",
      combo_addon_name_placeholder: "e.g. Drinks",
      combo_menu_type_locked: "Can't change the menu type while used by: {{combos}}",
      combo_change_menu_type_title: "Change menu type?",
      combo_change_menu_type_content:
        "Items belong to a menu type, so all items will be removed from the tiers.",
      combo_tiers: "Tiers",
      combo_tiers_help:
        "Each tier has one price for all its items. Leave points blank to use the restaurant's default redeem rate.",
      combo_add_tier: "Add tier",
      combo_tier_default_name: "{{price}} tier",
      combo_tier_label: "Tier label",
      combo_tier_price: "Tier price",
      combo_tier_points_help: "Points to redeem an item of this tier in a combo",
      combo_points_default: "Default: {{points}} pts",
      combo_not_redeemable: "Not redeemable",
      combo_duplicate_tier: "Duplicate tier",
      combo_remove_tier: "Remove tier",
      combo_copy_suffix: " (copy)",
      combo_tier_no_items: "No items yet",
      combo_regular_price_in_combo: "regular {{regular}} → {{combo}} in combo",
      combo_move_to_tier: "Move to tier",
      combo_tier_options_summary: "Options: {{summary}}",
      combo_tier_regular_option_prices: "regular prices",
      combo_option_free: "{{name}} free",
      combo_overridden_count: "{{count}} overridden",
      combo_option_pricing: "Option pricing",
      combo_option_pricing_help:
        "Override option prices for items in this add-on. Blank means inherit: a tier uses the All tiers price, otherwise the regular price.",
      combo_add_items_first: "Add items to the tiers to price their options.",
      combo_no_options_to_price: "The items in this add-on have no options.",
      combo_option_regular: "regular {{price}}",
      combo_all_tiers: "All tiers",
      combo_all_tiers_override_for: "{{name}} price in all tiers",
      combo_tier_override_for: "{{name}} price in {{tier}}",
      combo_per_tier: "Per tier ({{count}})",
      combo_inherits: "inherits {{price}}",
      combo_option_negative: "Makes the price negative ({{price}})",
      combo_option_negative_tiers: "Makes the price negative in: {{tiers}}",
      combo_fix_option_prices: "Some option prices would make a tier's price negative.",
      combo_addon_needs_tier: "Add at least one tier",
      combo_tier_needs_item: "{{tier}} needs at least one item",
      combo_failed_to_save_addon: "Failed to save add-on",
      combo_failed_to_load_addons: "Failed to load add-ons",
      combo_failed_to_delete_addon: "Failed to delete add-on",
      combo_used_by: "Used by",
      combo_not_used: "Not used",
      combo_used_by_n_combos: "Used by {{count}} combos",
      combo_used_by_n_combos_one: "Used by {{count}} combo",
      combo_used_by_n_combos_other: "Used by {{count}} combos",
      combo_addon_delete_in_use: "Can't delete while used by: {{combos}}",
      combo_delete_addon_confirm: "Delete add-on {{name}}?",
      delete_item_used_in_combos:
        "This item is used in combos: {{list}}. Deleting it removes it from them.",
      delete_item_combo_usage_entree: "{{name}} (entree)",
      delete_item_combo_usage_tier: "{{addon}} add-on ({{tier}})",
      delete_item_combo_usage_unknown: "Couldn't check whether this item is used in combos.",
    },
  },
  zh: {
    translation: {
      // ===== COMMON / SHARED =====
      cancel: "取消",
      clear: "清除",
      done: "完成",
      submit: "提交",
      save: "保存",
      delete: "刪除",
      edit: "編輯",
      add: "新增",
      create: "創建",
      search: "搜尋",
      filter: "篩選",
      export: "匯出",
      import: "匯入",
      refresh: "重新整理",
      back: "返回",
      next: "下一頁",
      previous: "上一頁",
      yes: "是",
      no: "否",
      ok: "確定",
      min: "最小值",
      max: "最大值",
      success: "成功",
      error: "錯誤",
      warning: "警告",
      info: "資訊",
      loading: "載入中",
      no_result: "無結果",
      try_searching_again: "請再次搜尋",
      name: "名稱",
      type: "類型",
      status: "狀態",
      actions: "操作",
      description: "描述",
      details: "詳細資訊",
      notes: "備註",
      enabled: "啟用",
      true: "是",
      false: "否",
      na: "不適用",
      enter: "確定",
      select_quantity: "選擇數量",

      // ===== STATS / DATA VISUALIZATION =====
      show_table: "顯示表格",
      show_plot: "顯示圖表",
      error_loading_statistics: "無法載入統計數據",
      please_adjust_date_range_and_retry: "如需要，請調整日期範圍並點擊查尋再試一次。",
      retry: "重試",

      // ===== NAVIGATION / HOME =====
      ticket_rails: "Ticket Rails",
      order_management_system: "訂單管理系統",
      workstations: "工作站",
      tools: "工具",
      order_management: "訂單管理",
      admin_functions: "管理功能",
      admin_dashboard: "管理儀表板",
      admin_dashboard_description: "訪問所有管理功能和設置",
      manager_functions: "經理功能",
      manager_dashboard: "經理儀表板",
      manager_dashboard_description: "查看統計數據和管理 QR 碼",
      welcome_manager_dashboard: "歡迎來到經理儀表板",
      manager_dashboard_welcome_description: "從側邊欄選擇功能或使用下方的快速操作",
      in_store_qr_code_description: "生成和管理店內點餐 QR 碼",

      // ===== ORDER MANAGEMENT =====
      master_control_station: "外場訂單控制台",
      completed_orders: "顯示完成訂單",
      ready_for_pickup: "可取餐",
      sorted_by_done_time: "依完成時間排序",
      online: "線上訂單",
      in_store: "店內",
      others: "其他",
      order_lookup: "訂單查尋",
      order_time: "下單時間",
      start_time: "開始時間",
      done_time: "完成時間",
      paid: "已付款",
      not_paid: "未付款",
      no_results: "沒有結果",
      error_occurred: "發生錯誤",
      created_successfully: "{{item}}已成功建立",
      created_successfully_generic: "已成功建立",
      updated_successfully: "{{item}}已成功更新",
      updated_successfully_generic: "已成功更新",
      saved_successfully: "{{item}}已成功儲存",
      saved_successfully_generic: "已成功儲存",
      deleted_successfully: "{{item}}已成功刪除",
      order_date_optional: "訂單日期(可不選,默認最近10筆訂單)",
      input_search_text: "輸入搜尋文字",
      back_to_search: "返回搜尋",
      search_for: "搜尋:",
      searching: "搜尋中...",
      virtual_keyboard_hint: "使用螢幕鍵盤輸入搜尋文字。",
      space: "空格",
      backspace: "退格",
      phone: "電話",
      email: "電子郵件",
      immediate: "立刻",
      within_minutes: "{{minutes}}分鐘內",
      more_than_minutes: ">{{minutes}}分鐘",
      more_than_hours: ">{{hours}}小時",
      pickup_time: "取餐時間",
      customer: "顧客",
      item: "項",
      items: "項",
      unable_to_connect: "無法連線",
      retrying: "重新嘗試中...",
      no_orders: "沒有訂單",
      no_done_orders: "沒有完成的訂單",
      no_items: "沒有餐點",
      start_button: "開始",
      done_button: "完成",
      in_progress: "進行中",
      not_started: "未開始",
      pending: "待處理",
      pending_orders: "待處理",
      started: "進行中",
      started_orders: "進行中",
      completed: "完成",
      filter_by_item: "依餐點篩選",
      order: "訂單",
      create_time: "建立時間",
      action: "操作",
      shipping_label: "運送標籤",
      packing_list: "包裝清單",
      quantity: "數量",
      total_quantity: "總數量",
      customer_information: "客戶資訊",
      address: "地址",
      pretax_price: "稅前價格",
      handling_fee: "手續費",
      failed_to_fetch_data: "無法取得資料",
      of: "共",
      order_incomplete_warning: "這個單好像不完整。Clover可能有問題。",
      select_reminder_time: "請選擇提醒時間",
      reminder_set: "我會在{{time}}提醒您",
      remind_me: "提醒我",
      reminder_cancelled: "已取消提醒",
      cancel_reminder: "取消提醒",
      points_claimed: "已領取點數",
      unable_to_print: "無法列印",
      unable_to_reprint_labels: "無法重印標籤",
      unable_to_print_points: "無法列印點數",
      print_points: "列印點數",
      print: "列印",
      print_order_ticket: "列印訂單",
      reprint_labels: "重印標籤",
      print_beverage_labels: "列印飲料標籤",
      print_non_beverage_labels: "列印食物標籤",
      auto_print_on_start: "開始時自動列印標籤",
      auto_print_off: "自動列印關閉",
      on: "開",
      off: "關",
      please_try_again_later: "請稍後再試",
      unable_to_fetch_tables: "無法取得座位",
      unable_to_add_table: "無法新增座位",
      unable_to_fetch_order_history: "無法取得訂單紀錄",
      unable_to_fetch_points_history: "無法取得點數紀錄",
      sorry_error_occurred: "抱歉，發生錯誤!",
      reload: "重新載入",
      selected: "已選擇",

      // ===== WORKSTATION NAMES =====
      station: "台",
      workstation_fry: "炸台",
      workstation_grill: "烤台",
      workstation_rice: "打飯台",
      workstation_assembly: "組裝台",
      workstation_prep: "抓料台",

      // ===== ADMIN FUNCTIONS =====
      edit_menu: "編輯菜單",
      edit_menu_description: "管理您的餐廳菜單項目",
      edit_customization_options: "編輯客制化選項",
      announcement_settings: "公告設定",
      manage_members: "管理客戶",
      manage_members_description: "查看和管理客戶帳戶",
      statistics: "統計",
      statistics_description: "查看性能分析和洞察",
      reports: "報表",
      in_store_qr_code: "店內 QR Code",
      shipping_orders: "郵寄訂單",
      shipping_orders_description: "管理配送和郵寄訂單",
      feature_flags: "功能標誌",
      printer_management: "印表機管理",
      custom_order_page: "客製化訂單頁面",
      menu_management: "菜單管理",
      large_volume_management: "團購管理",
      members_management: "客戶管理",
      orders_management: "訂單管理",
      data_analytics: "數據與分析",
      settings: "設置",
      back_to_home: "返回首頁",
      welcome_admin_dashboard: "歡迎來到管理儀表板",
      admin_dashboard_welcome_description: "從側邊欄選擇功能或使用下面的快速操作",
      quick_actions: "快速操作",
      all_functions: "所有功能",
      search_by_name: "按名稱搜尋",

      // ===== LOGIN =====
      login: "登入",
      account: "帳號",
      password: "密碼",
      please_enter_account: "請輸入帳號",
      please_enter_password: "請輸入密碼",
      required_to_login_with_admin_account: "必須使用管理員帳號登入才能使用",
      no_restaurants_for_account: "此帳號沒有可用的餐廳",
      failed_to_login: "登入失敗",

      // ===== TRID CONVERTER =====
      trid_converter_title: "TRID 轉換器",
      trid_converter_description: "在 UUID 與 TicketRails ID 之間進行轉換。",
      trid_converter_uuid_to_trid: "UUID 轉 TRID",
      trid_converter_trid_to_uuid: "TRID 轉 UUID",
      trid_converter_uuid: "UUID",
      trid_converter_trid: "TRID",
      trid_converter_tag: "標籤",
      trid_converter_uuid_placeholder: "600f2814-c7d7-438c-b419-d813b15966aa",
      trid_converter_trid_placeholder: "its_YA8oFMfXQ4y0GdgTsVlmqg",
      trid_converter_tag_placeholder: "its",
      trid_converter_result_placeholder: "轉換結果將顯示於此",
      trid_converter_tag_help: "請輸入三個小寫英文字母的資源標籤。",
      trid_converter_invalid_uuid: "請輸入有效的 UUID。",
      trid_converter_invalid_tag: "標籤必須由三個小寫英文字母組成。",
      trid_converter_invalid_trid: "請輸入有效的 TRID。",
      trid_converter_invalid_trid_payload: "TRID 未包含有效的 UUID。",
      trid_converter_trid_result: "轉換後的 TRID",
      trid_converter_uuid_result: "轉換後的 UUID",
      trid_converter_tag_result: "TRID 標籤",
      trid_converter_copy_trid: "複製 TRID",
      trid_converter_copy_uuid: "複製 UUID",
      trid_converter_copied: "已複製",
      trid_converter_local_only: "所有轉換均在您的瀏覽器本機完成。",

      // ===== RESTAURANT SELECTION =====
      select_restaurant: "選擇餐廳",
      select_restaurant_description: "選擇要管理的餐廳",
      switch_restaurant: "切換餐廳",
      select: "選擇",

      // ===== ITEM MODIFICATION SCHEMA =====
      add_customization_option: "新增客制化選項",
      option_name: "選項名稱",
      please_enter_option_name: "請輸入選項名稱",
      allow_multiple_selection: "允許多選",
      optional: "可不選",
      option_list: "選項清單",
      add_option: "新增選項",
      price_adjustment: "價格調整",
      default: "預設",
      edit_customization_option: "編輯客制化選項",
      delete_customization_option_confirm: "確定刪除客制化選項？",
      delete_customization_option_description: "此操作無法撤銷。使用此選項的品項將會受到影響。",

      // ===== MENU EDITOR =====
      menu_item_name: "菜單品名",
      receipt_name: "收據品名",
      kitchen_chinese_name: "廚房中文名稱",
      kitchen_spanish_name: "廚房西班牙文名稱",
      kitchen_english_name: "廚房英文名稱",
      key_example: "按鍵 (例如: R3, A4)",
      price: "價格",
      points: "點數",
      points_config: "點數設定",
      failed_to_fetch_points_config: "無法取得點數設定",
      failed_to_update_points_config: "無法更新點數設定",
      use_automatic_redeem_rate: "使用自動兌換率",
      use_automatic_redeem_rate_description:
        "開啟後，未設定點數的商品將依此兌換率（根據價格）成為可兌換；已設定點數的商品則維持原值。",
      redeem_rate: "兌換率",
      redeem_rate_description:
        "每 $1 的預設點數，僅用於未設定點數的商品。價格無條件進位至整數美元。",
      redeem_rate_required_when_enabled: "開啟自動兌換率時必須設定兌換率。",
      redeem_rate_must_be_positive: "兌換率必須大於 0。",
      points_per_dollar: "點 / $",
      redeem_rate_preview: "一份未設定點數的 $10 商品需要 {{points}} 點兌換。",
      points_redeem_rate_fallback: "留空則使用兌換率（此價格約 {{points}} 點）。",
      wait_config: "取餐等待時間設定",
      failed_to_fetch_wait_config: "無法取得取餐等待時間設定",
      failed_to_update_wait_config: "無法更新取餐等待時間設定",
      wait_config_intro:
        "取餐等待時間會隨廚房負載（以備餐點數計算）增加。每項餐點依其製作工作站的備餐權重累計點數（在工作站頁面設定）。",
      base_wait_minutes: "基本等待時間",
      base_wait_minutes_description: "廚房空閒時顯示的最短等待時間。",
      points_per_step: "每階負載點數",
      points_per_step_description: "每累積此備餐點數，等待時間增加一階。",
      step_minutes: "每階增加時間",
      step_minutes_description: "每滿一階負載增加的分鐘數。",
      max_wait_minutes: "最長等待時間",
      max_wait_minutes_description: "等待時間上限，不論廚房負載多高。",
      large_order_points: "大單門檻",
      large_order_points_description:
        "超過此備餐點數的訂單視為大單：大單會計入全部廚房待做量，且不會延誤小單。",
      minutes: "分鐘",
      load_points: "備餐點數",
      wait_config_minutes_range: "必須介於 1 到 {{max}} 分鐘之間。",
      wait_config_step_minutes_range: "必須介於 0 到 {{max}} 分鐘之間。",
      wait_config_points_range: "必須介於 1 到 {{max}} 點之間。",
      max_wait_must_be_gte_base: "最長等待時間不可小於基本等待時間。",
      wait_config_summary:
        "等待時間從 {{base}} 分鐘起，每 {{pointsPerStep}} 點廚房負載增加 {{step}} 分鐘，上限 {{max}} 分鐘。超過 {{largeOrderPoints}} 點的訂單視為大單。",
      prep_weight: "備餐權重",
      prep_weight_description:
        "此工作站每個動作累計的廚房負載點數（例如油炸 = 3、飯 = 1、組裝 = 0），用於計算取餐等待時間。",
      prep_weight_unit: "點 / 動作",
      prep_weight_range: "備餐權重必須介於 0 到 {{max}} 之間。",
      failed_to_update_prep_weight: "無法更新備餐權重",
      tax_free: "免稅",
      shippable: "可郵寄",
      weight_grams: "重量 (公克)",
      print_label: "印標籤貼紙",
      sold_out: "售完",
      featured: "精選",
      actions_workstation: "工作區",
      modifications_customization: "客制化選項",
      upload_image: "上傳圖片",
      saving: "儲存中...",
      name_is_required: "名稱為必填。",
      price_is_required: "價格為必填。",
      weight_is_required_for_shippable: "可郵寄商品必須填寫重量。",
      select_menu_type: "選擇菜單類型",
      dine_in_pickup: "內用 / 外帶",
      group_order: "團購",
      notification_time_minutes: "通知時間 (分鐘)",
      limited_quantity: "限量商品",
      quantity_limit: "總數量限制",
      quantity_limit_help: "最大供應量。留空表示無限制。",
      quantity_limit_placeholder: "無限制",
      per_order_quantity_limit: "每單數量限制",
      per_order_quantity_limit_help: "每筆訂單最大數量。留空表示無限制。",
      per_order_quantity_limit_placeholder: "無限制",
      limited_quantity_inventory: "限量商品庫存",
      consumption_trend: "消耗趨勢",
      no_limited_quantity_items: "尚未設定限量商品。",
      select_item: "選擇商品",
      select_an_item_to_view_trend: "請選擇商品以查看消耗趨勢。",
      no_trend_data: "選取區間內無消耗資料。",
      consumed: "已消耗",
      reserved: "已預約",
      remaining: "剩餘",
      delete_menu_item_confirm: "您確定要刪除 {{name}} 嗎？",
      delete_menu_item_description: "此操作無法復原。",
      create_item: "新增品項",
      image: "圖片",
      bulk_update_success: "成功更新 {{count}} 個品項！",
      bulk_update_partial_failure:
        "{{total}} 個品項中有 {{success}} 個更新成功，{{failed}} 個失敗。",

      // ===== MEMBERS =====
      email_or_phone: "電子郵件或電話",
      member_since: "會員加入日期",
      order_history: "訂單紀錄",
      points_history: "點數紀錄",
      adjust_points: "調整點數",
      search_member: "搜尋會員",
      member_information: "會員資訊",
      member_not_found: "會員不存在",
      unable_to_search_member: "無法搜尋會員",
      email_or_phone_is_required: "電子郵件或電話為必填。",
      points_is_required: "點數為必填。",
      expiration: "有效期限",
      expiration_date_required_for_credits: "新增點數時必須設定有效期限。",
      manually_added_by_restaurant: "由餐廳手動新增",
      added_points_successfully: "成功新增 {{delta}} 點數！",

      // ===== ANNOUNCEMENTS =====
      title: "標題",
      content: "內容",
      create_new_announcement: "新增公告",
      current_announcements: "目前公告",
      no_announcements: "尚無公告",
      system_shutdown_control: "系統停止營業控制",
      title_is_required: "標題為必填。",
      announcement_type_is_required: "公告類型為必填。",
      added_new_announcement_successfully: "成功新增公告！",
      open_restaurant: "重新營業",
      shutdown_restaurant: "暫時停止營業",
      reopen: "重新營業",
      temporarily_closed: "暫時停止營業",
      are_you_sure_reopen: "您確定要重新營業嗎？",
      are_you_sure_shutdown: "您確定要暫時停止營業嗎？",
      restaurant_shutdown_successfully: "餐廳已暫停營業！",
      restaurant_reopened_successfully: "餐廳已重新營業！",
      temporary_closure: "暫時停止營業",
      sorry_temporarily_closed: "不好意思我們目前暫時停止營業。",

      // ===== FEATURE FLAGS =====
      flag_name: "功能標誌名稱",
      enabled_is_required: "啟用狀態為必填。",
      updated_feature_flag_successfully: "成功更新功能標誌！",
      failed_to_save_feature_flag: "儲存功能標誌失敗",
      failed_to_fetch_flags: "取得功能標誌失敗",
      update_flag: "更新功能標誌",
      current_flags: "目前功能標誌",
      no_flags_available: "沒有可用的功能標誌",
      flags: "功能標誌",

      // ===== PRINTER MANAGEMENT =====
      saved_printers: "已儲存的印表機",
      add_a_printer: "新增印表機",
      select_printer_type: "選擇印表機類型",
      manage_connected_printers: "管理您已連接的印表機",
      no_saved_printers: "尚無已儲存的印表機",
      no_available_printers: "沒有可用的印表機",
      make_sure_printer_plugged_in: "請確保印表機已開啟並已連線。",
      select_type_for_printer: "選擇此印表機的類型",
      failed_to_load_connected_printers: "載入已連接的印表機失敗。",
      printer_added_successfully: "成功新增印表機。",
      failed_to_add_printer: "新增印表機失敗。可能已經連接。",
      printer_deleted_successfully: "成功刪除印表機。",
      failed_to_delete_printer: "刪除印表機失敗。",
      serial: "序號",
      vendor_id: "供應商 ID",
      product_id: "產品 ID",
      add_a_usb_printer: "新增 USB 印表機",
      add_a_network_printer: "新增網路印表機",
      scan_for_new_printers: "掃描新印表機",
      scanning_for_printers: "正在掃描新印表機",
      this_will_take_around_10_seconds: "大約需要 10 秒鐘",
      printer_scan_complete: "印表機掃描完成",
      print_test_page: "列印測試頁",
      test_page_printed_successfully: "測試頁已成功列印。",
      failed_to_print_test_page: "列印測試頁失敗。",
      only_one_printer_per_type: "每種印表機類型只能儲存一台印表機。",
      printer_type_already_added:
        "已儲存一台 {{type}} 印表機。請先移除現有的 {{type}} 印表機,才能新增另一台。",
      printer_type_already_added_short: "已新增",
      all_printer_types_already_added: "每種印表機類型都已儲存一台印表機。請先移除其中一台再新增。",

      // ===== WORKSTATION =====
      clear_all_items: "你確定要全部清除嗎?",

      // ===== QR CODES =====
      qr_code_management: "QR Code 管理",
      table_number: "桌號",
      generate_qr_code: "產生 QR Code",
      create_new_qr_code: "建立新 QR Code",
      current_qr_codes: "目前 QR Code",
      no_qr_codes_message: "尚無 QR Code，建立一個開始吧！",
      total_qr_codes: "總共 {{total}} 個 QR Code",

      // ===== SHIPPING =====
      shipping_management: "郵寄管理",
      shipping_orders_management: "郵寄訂單管理",
      tracking_number: "追蹤號碼",
      shipping_address: "郵寄地址",
      order_status: "訂單狀態",

      // ===== STATS & REPORTS =====
      view_statistics: "查看統計",
      generate_report: "產生報表",
      date_range: "日期範圍",
      start_date: "開始日期",
      end_date: "結束日期",
      total_orders: "總訂單數",
      total_revenue: "總營收",
      average_order_value: "平均訂單金額",
      select_month: "選擇月份",
      order_report: "訂單報表",
      current_month_to_date: "本月至今",

      // ===== CAMPAIGNS =====
      campaign_name: "活動名稱",
      campaigns: "活動",
      create_campaign: "建立活動",
      copy_campaign: "複製活動",
      campaign_copy_prefix: "複製 - ",
      campaign_status: "狀態",
      campaign_status_past: "過去",
      campaign_status_active: "進行中",
      campaign_status_scheduled: "已排程",
      campaigns_load_failed: "載入活動失敗",
      campaign: "活動",
      campaign_pending: "{{name}} - 待處理",
      campaign_done: "{{name}} - 完成",
      no_campaigns: "找不到活動",
      campaign_export_paid_orders: "匯出已付款訂單",
      campaign_export_failed: "匯出已付款訂單失敗",
      campaign_no_paid_orders: "此活動尚無已付款訂單",
      campaign_summary_load_failed: "載入活動摘要失敗",
      campaign_paid_orders: "已付款訂單",
      campaign_item_name: "品項",
      campaign_item_modifications: "客製化選項",
      not_available: "不適用",
      campaign_type: "活動類型",
      campaign_basic_information: "活動基本資訊",
      schedule_settings: "排程設定",
      select_menu_items: "選擇菜單項目",
      slug: "短網址",
      ticket_prefix: "票券前綴",
      order_deadline_date: "訂單截止日期",
      order_deadline_time: "訂單截止時間",
      fulfillment_start_date: "配送開始日期",
      fulfillment_end_date: "配送結束日期",
      fulfillment_date_range: "配送日期範圍",
      fulfillment_time_start: "配送開始時間",
      fulfillment_time_end: "配送結束時間",
      is_batch_delivery: "批次配送",
      save_campaign: "儲存活動",
      please_input_name: "請輸入名稱",
      please_input_slug: "請輸入短網址",
      please_input_ticket_prefix: "請輸入票券前綴",
      please_select_date: "請選擇日期",
      please_select_time: "請選擇時間",
      total_items_count: "總共 {{total}} 項",

      // ===== FORM VALIDATION =====
      this_field_is_required: "此欄位為必填",
      please_enter_valid_email: "請輸入有效的電子郵件",
      please_enter_valid_phone: "請輸入有效的電話號碼",

      // ===== TOOLTIPS =====
      tooltip_back: "返回首頁",
      tooltip_printer: "印表機管理",
      tooltip_refresh: "重新整理頁面",
      tooltip_logout: "登出",

      // ===== HEADER MENU =====
      language: "語言",
      logout: "登出",
      choose_your_language: "選擇您的語言",
      language_preference_saved: "您的語言偏好將自動儲存",

      // ===== INTEGRATIONS =====
      integrations: "整合",
      square_integrations: "Square 整合",
      add_square_integration: "新增 Square 整合",
      current_integrations: "目前的整合",
      failed_to_fetch_integrations: "讀取整合失敗",
      failed_to_create_integration: "建立整合失敗",
      failed_to_delete_integration: "刪除整合失敗",
      delete_integration_confirm: "您確定要刪除此整合嗎？",
      delete_integration_description: "此操作無法復原。",
      no_integrations_available: "沒有可用的整合",
      access_token: "Access Token",
      access_token_required: "必須填寫 Access Token",
      enter_access_token: "輸入 Access Token",
      location_id: "LocationID",
      location_id_required: "必須填寫 LocationID",
      enter_location_id: "輸入 LocationID",
      tax_percentage: "稅率百分比",
      tax_percentage_tooltip: "適用於線上訂單的稅率。",
      enter_tax_percentage: "輸入稅率百分比 (例如: 9.25)",
      tax_percentage_required: "使用線上付款時必須填寫稅率百分比",
      tax_percentage_invalid_format: "請輸入有效的數字，最多五位小數",
      edit_tax_percentage: "編輯稅率",
      enter_tax_percentage_6_decimals: "請輸入正數，最多六位小數。",
      tax_percentage_invalid_format_6_decimals: "請輸入有效的正數，最多六位小數",
      tax_percentage_must_be_positive: "稅率百分比必須為正數",
      failed_to_update_tax_percentage: "更新稅率百分比失敗",
      use_for_online_payment: "用於線上支付",
      create_integration: "建立整合",
      merchant_id: "MerchantID",

      // ===== WORKSTATION SCHEMAS =====
      workstation_schemas: "工作站",
      workstation_schema: "工作站",
      add_workstation_schema: "新增工作站",
      edit_workstation_schema: "編輯工作站",
      current_workstation_schemas: "目前的工作站",
      no_workstation_schemas_available: "沒有可用的工作站",
      failed_to_fetch_workstation_schemas: "讀取工作站失敗",
      failed_to_create_workstation_schema: "建立工作站失敗",
      failed_to_update_workstation_schema: "更新工作站失敗",
      failed_to_delete_workstation_schema: "刪除工作站失敗",
      delete_workstation_schema_confirm: "您確定要刪除此工作站嗎？",
      delete_workstation_schema_description: "此操作無法復原。",
      enter_workstation_name: "輸入工作站名稱",

      // ===== ITEM SCHEMA GROUPS =====
      item_schema_groups: "品項群組",
      item_schema_group: "品項群組",
      add_item_schema_group: "新增品項群組",
      edit_item_schema_group: "編輯品項群組",
      current_item_schema_groups: "目前的品項群組",
      no_item_schema_groups_available: "沒有可用的品項群組",
      failed_to_fetch_item_schema_groups: "讀取品項群組失敗",
      failed_to_create_item_schema_group: "建立品項群組失敗",
      failed_to_update_item_schema_group: "更新品項群組失敗",
      failed_to_delete_item_schema_group: "刪除品項群組失敗",
      delete_item_schema_group_confirm: "您確定要刪除此品項群組嗎？",
      delete_item_schema_group_description: "此操作無法復原。",
      enter_group_name: "輸入群組名稱",
      menu_type: "菜單類型",
      menu_type_is_required: "菜單類型為必填",
      sequence: "順序",
      sequence_is_required: "順序為必填",
      enter_sequence: "輸入順序編號",

      // ===== RESTAURANT PUBLIC INFO =====
      restaurant_public_info: "餐廳資訊",
      failed_to_fetch_restaurant_public_info: "讀取餐廳資訊失敗",
      failed_to_update_restaurant_public_info: "更新餐廳資訊失敗",
      enter_address: "輸入地址",
      business_hours: "營業時間",
      open_time: "開店時間",
      close_time: "關店時間",
      select_open_time: "選擇開店時間",
      select_close_time: "選擇關店時間",
      social_media_links: "社群媒體連結",
      instagram_url: "Instagram 網址",
      google_url: "Google 網址",
      yelp_url: "Yelp 網址",
      facebook_url: "Facebook 網址",
      enter_instagram_url: "輸入 Instagram 網址",
      enter_google_url: "輸入 Google 網址",
      enter_yelp_url: "輸入 Yelp 網址",
      enter_facebook_url: "輸入 Facebook 網址",
      ordering_links: "訂購連結",
      order_url: "訂購網址",
      order_url_help: "由我們管理的訂購網站網址。不適用時請留空。",
      enter_order_url: "輸入訂購網址",
      delivery_url: "外送網址",
      delivery_url_help: "第三方外送訂購網址（例如 DoorDash）。不提供外送時請留空。",
      enter_delivery_url: "輸入外送網址",
      public_listing: "公開列表",
      listed: "已列出",
      listed_help: "此餐廳是否顯示在訂購網站的公開分店列表中。",
      coming_soon: "即將開幕",
      coming_soon_help:
        "已列出但尚未正式營業的分店：在訂購網站上顯示資訊與「即將開幕」標示，但無法下單。",
      coming_soon_requires_listed: "分店必須先設為已列出才能標示為即將開幕。",
      default_tip_percentages: "預設小費百分比",
      tip_option_1: "小費選項 1",
      tip_option_2: "小費選項 2",
      tip_option_3: "小費選項 3",

      // ===== LARGE VOLUME DELIVERY =====
      large_volume_delivery: "團購外送",
      delivery_zones: "配送區域",
      delivery_zone: "配送區域",
      add_delivery_zone: "新增配送區域",
      edit_delivery_zone: "編輯配送區域",
      current_delivery_zones: "目前的配送區域",
      no_delivery_zones_available: "沒有可用的配送區域",
      failed_to_fetch_delivery_zones: "讀取配送區域失敗",
      failed_to_create_delivery_zone: "建立配送區域失敗",
      failed_to_update_delivery_zone: "更新配送區域失敗",
      failed_to_delete_delivery_zone: "刪除配送區域失敗",
      delete_delivery_zone_confirm: "您確定要刪除此配送區域嗎？",
      delete_delivery_zone_description: "此操作無法復原。",
      zone_name: "區域名稱",
      enter_zone_name: "輸入區域名稱",
      minimum_pretax_price: "最低稅前價格",
      minimum_pretax_price_is_required: "最低稅前價格為必填",
      enter_minimum_pretax_price: "輸入最低稅前價格",
      delivery_fee: "配送費",
      delivery_fee_is_required: "配送費為必填",
      enter_delivery_fee: "輸入配送費",
      free_delivery_threshold: "免運門檻",
      free_delivery_threshold_is_required: "免運門檻為必填",
      enter_free_delivery_threshold: "輸入免運門檻",
      postal_codes: "郵遞區號",
      postal_code: "郵遞區號",
      add_postal_code: "新增郵遞區號",
      edit_postal_code: "編輯郵遞區號",
      current_postal_codes: "目前的郵遞區號",
      no_postal_codes_available: "沒有可用的郵遞區號",
      failed_to_fetch_postal_codes: "讀取郵遞區號失敗",
      failed_to_create_postal_code: "建立郵遞區號失敗",
      failed_to_update_postal_code: "更新郵遞區號失敗",
      failed_to_delete_postal_code: "刪除郵遞區號失敗",
      delete_postal_code_confirm: "您確定要刪除此郵遞區號嗎？",
      delete_postal_code_description: "此操作無法復原。",
      postal_code_is_required: "郵遞區號為必填",
      enter_postal_code: "輸入郵遞區號",
      delivery_zone_is_required: "配送區域為必填",
      select_delivery_zone: "選擇配送區域",
      create_delivery_zone_first: "請先建立配送區域",

      // ===== LARGE VOLUME PICKUP CONFIG =====
      large_volume_pickup_config: "團購自取設定",
      no_large_volume_pickup_config_available: "沒有可用的團購自取設定",
      failed_to_fetch_large_volume_pickup_config: "讀取團購自取設定失敗",
      failed_to_create_large_volume_pickup_config: "建立團購自取設定失敗",
      failed_to_update_large_volume_pickup_config: "更新團購自取設定失敗",
      failed_to_delete_large_volume_pickup_config: "刪除團購自取設定失敗",

      promo_codes: "優惠代碼",
      promo_code: "優惠代碼",
      create_promo_code: "建立優惠代碼",
      no_promo_codes_available: "沒有可用的優惠代碼",
      failed_to_fetch_promo_codes: "取得優惠代碼失敗",
      failed_to_create_promo_code: "建立優惠代碼失敗",
      failed_to_update_promo_code: "更新優惠代碼失敗",
      failed_to_fetch_item_schemas: "取得品項失敗",
      promo_slug: "代碼",
      slug_is_required: "代碼為必填",
      slug_max_length: "代碼最長 100 字元",
      slug_placeholder: "例如 SAVE10",
      promo_description: "說明",
      description_placeholder: "選填的管理員說明",
      promo_discount: "折扣",
      discount_type: "折扣類型",
      percent_of_order_total: "訂單總額百分比",
      fixed_amount: "固定金額",
      discount_percent: "折扣百分比",
      discount_amount: "折扣金額",
      discount_value_is_required: "折扣值為必填",
      discount_percent_range: "百分比需介於 1 到 100",
      discount_amount_positive: "金額需為正數",
      promo_expire_time: "到期時間",
      expire_time_is_required: "到期時間為必填",
      edit_expire_time: "編輯到期時間",
      expired: "已過期",
      promo_conditions: "條件",
      promo_min_spend: "最低消費",
      min_spend_conditions: "最低消費條件",
      min_spend_is_required: "最低消費為必填",
      add_min_spend_condition: "新增最低消費條件",
      item_conditions: "品項條件",
      promo_item: "品項",
      item_is_required: "品項為必填",
      quantity_is_required: "數量為必填",
      promo_select_item: "選擇品項",
      add_item_condition: "新增品項條件",
      promo_code_condition_required_notice: "至少需要一個條件（最低消費或品項）。",
      counts_towards_min_spend: "計入最低消費",
      excludes_from_min_spend: "不計入最低消費",
      promo_item_excludes_min_spend: "不計入最低消費",
      promo_item_min_spend_help: "關閉時，此品項的所需數量不計入最低消費。",

      // ===== PREPAID CARDS =====
      view: "檢視",
      publish: "發布",
      archive: "封存",
      close: "關閉",
      exclusive_end: "不含當日",
      day_sun: "星期日",
      day_mon: "星期一",
      day_tue: "星期二",
      day_wed: "星期三",
      day_thu: "星期四",
      day_fri: "星期五",
      day_sat: "星期六",
      day_sun_abbr: "日",
      day_mon_abbr: "一",
      day_tue_abbr: "二",
      day_wed_abbr: "三",
      day_thu_abbr: "四",
      day_fri_abbr: "五",
      day_sat_abbr: "六",

      prepaid_cards: "預付卡",
      prepaid_card: "預付卡",
      prepaid_card_stats: "預付卡統計",
      prepaid_card_create: "建立預付卡",
      prepaid_card_edit: "編輯預付卡",
      prepaid_card_view: "檢視預付卡",
      prepaid_card_none_available: "沒有可用的預付卡",
      failed_to_fetch_prepaid_cards: "取得預付卡失敗",
      failed_to_create_prepaid_card: "建立預付卡失敗",
      failed_to_update_prepaid_card: "更新預付卡失敗",
      failed_to_publish_prepaid_card: "發布預付卡失敗",
      failed_to_archive_prepaid_card: "封存預付卡失敗",
      failed_to_delete_prepaid_card: "刪除預付卡失敗",
      prepaid_card_published_successfully: "預付卡已成功發布",
      prepaid_card_archived_successfully: "預付卡已成功封存",
      prepaid_card_deleted_successfully: "預付卡已成功刪除",
      prepaid_card_price: "價格",
      prepaid_card_price_is_required: "價格為必填",
      prepaid_card_price_positive: "價格需為正數",
      prepaid_card_redeem_count: "兌換次數",
      prepaid_card_redeem_count_is_required: "兌換次數為必填",
      prepaid_card_redeem_count_positive: "兌換次數需為正數",
      prepaid_card_redeems_lowercase: "次兌換",
      prepaid_card_tax_free: "免稅",
      prepaid_card_supported_items: "適用品項",
      prepaid_card_supported_items_required: "至少需要一個適用品項",
      prepaid_card_select_items: "選擇適用品項",
      prepaid_card_redeem_window: "兌換期間",
      prepaid_card_redeem_window_required: "兌換期間為必填",
      prepaid_card_redeem_window_help: "結束日期不含當日。",
      prepaid_card_redeem_days: "可兌換星期",
      prepaid_card_redeem_days_required: "至少需要一個可兌換星期",
      prepaid_card_purchase_window: "銷售期間",
      prepaid_card_purchase_window_required: "銷售期間為必填",
      prepaid_card_image: "圖片",
      prepaid_card_name_placeholder: "例如：10 份午餐便當",
      prepaid_card_published_readonly_notice:
        "此預付卡已發布，無法再編輯。您仍可將其封存以停止新銷售。",
      prepaid_card_publish_confirm_title: "發布「{{name}}」？",
      prepaid_card_publish_warning:
        "一旦發布，此預付卡即無法再變更 — 價格、兌換次數、適用品項與兩個日期區間都將固定，因為顧客將依這些條款購買。您仍可將其封存以停止新銷售。",
      prepaid_card_archive_confirm_title: "封存「{{name}}」？",
      prepaid_card_archive_confirm_body: "封存後將從新銷售中隱藏此卡。已購買的卡仍可正常使用。",
      prepaid_card_delete_confirm_title: "刪除「{{name}}」？",
      prepaid_card_delete_confirm_body: "此草稿預付卡將被永久刪除。",
      prepaid_card_delete_disabled_sold: "無法刪除：此卡已有銷售紀錄",
      prepaid_card_cards_sold: "已售出張數",
      prepaid_card_cards_pending_payment: "待付款",
      prepaid_card_gross_revenue: "總收入",
      prepaid_card_counts_sold: "已售出次數",
      prepaid_card_counts_redeemed: "已兌換次數",
      prepaid_card_counts_reserved: "保留中次數",
      prepaid_card_outstanding_redeems: "未兌換次數",
      prepaid_card_expired_redeems: "已過期",
      prepaid_card_liability: "潛在負債",
      prepaid_card_total_outstanding_redeems: "未兌換總次數",
      prepaid_card_total_outstanding_liability: "未兌換總負債",
      prepaid_card_no_stats_available: "沒有可用的預付卡統計",
      prepaid_card_supported_items_unavailable: "無法取得適用品項",
      prepaid_card_status_draft: "草稿",
      prepaid_card_status_scheduled: "已排程",
      prepaid_card_status_live: "銷售中",
      prepaid_card_status_ended: "已結束",
      prepaid_card_status_archived: "已封存",

      // ===== POINT GIFT CARDS =====
      point_gift_cards: "點數禮品卡",
      point_gift_card: "點數禮品卡",
      add_point_gift_card: "新增點數禮品卡",
      current_gift_cards: "目前的禮品卡",
      no_gift_cards_available: "沒有可用的禮品卡",
      no_gift_cards_match_search: "沒有符合搜尋條件的禮品卡",
      failed_to_fetch_gift_cards: "讀取禮品卡失敗",
      failed_to_create_gift_card: "建立禮品卡失敗",
      failed_to_delete_gift_card: "刪除禮品卡失敗",
      failed_to_download_qr_code: "下載 QR 碼失敗",
      download_qr_code: "下載 QR 碼 (PNG)",
      download_sign: "下載可列印標示牌 (PDF)",
      download_all_signs: "下載全部標示牌",
      download_selected_signs: "下載所選 ({{count}})",
      failed_to_download_sign: "下載標示牌失敗",
      order_type: "訂單類型",
      dine_in: "內用",
      to_go: "外帶",
      order_type_is_required: "訂單類型為必填。",
      added_new_table_successfully: "新增桌位成功！",
      delete_table_confirm: "刪除 {{name}}？",
      preview_sign: "預覽標示牌",
      delete_gift_card_confirm: "您確定要刪除此禮品卡嗎？",
      delete_gift_card_description: "此操作無法復原。",
      cannot_delete_claimed_card: "無法刪除已領取的禮品卡",
      create_gift_card: "建立禮品卡",
      gift_cards: "張禮品卡",
      description_is_required: "描述為必填",
      enter_description: "輸入描述",
      amount: "數量",
      amount_is_required: "數量為必填",
      amount_must_be_greater_than_zero: "數量必須大於 0",
      enter_amount: "輸入數量",
      expiry_date: "有效期限",
      expiry_date_tooltip: "選填。留空表示無期限。",
      select_expiry_date: "選擇有效期限",
      claimed: "已領取",
      qr_code: "QR 碼",
      search_by_amount_or_description: "依數量或描述搜尋",

      // ===== COMMON FORM =====
      total: "總計",
      reset: "重設",

      // ===== USER MANAGEMENT =====
      user_management: "使用者管理",
      add_user: "新增使用者",
      edit_roles: "編輯權限",
      reset_password: "重設密碼",
      change_password: "變更密碼",
      send_invite: "傳送邀請",
      remove_user: "移除使用者",
      no_users_available: "沒有使用者",
      failed_to_fetch_users: "無法取得使用者清單",
      failed_to_create_user: "無法新增使用者",
      failed_to_update_roles: "無法更新權限",
      failed_to_reset_password: "無法重設密碼",
      failed_to_change_password: "無法變更密碼",
      failed_to_remove_user: "無法移除使用者",
      failed_to_send_invite: "無法傳送邀請",
      user_created_successfully: "使用者已建立",
      user_created_send_invite_hint: "使用者已建立。請使用「傳送邀請」讓使用者設定密碼。",
      user_added_to_restaurant: "使用者已加入餐廳",
      user_removed_successfully: "使用者已移除",
      roles_updated_successfully: "權限已更新",
      password_reset_successfully: "密碼已重設",
      password_changed_successfully: "密碼已變更",
      password_changed_please_login: "密碼已變更，請重新登入。",
      invite_sent_successfully: "邀請已傳送",
      remove_user_confirm: "確定要移除此使用者嗎？",
      remove_user_description: "此使用者將無法再存取此餐廳。",
      cannot_remove_yourself: "您無法移除自己",
      cannot_modify_admin: "無法修改其他管理員",
      you: "您",
      roles: "權限",
      role: "權限",
      role_admin: "管理員",
      role_manager: "經理",
      role_regular_user: "一般使用者（無特殊權限）",
      roles_help: "留空則為一般使用者權限",
      please_select_roles: "請至少選擇一個權限",
      please_enter_email: "請輸入電子郵件",
      enter_email: "輸入電子郵件",
      user_exists_info: "使用者已存在",
      user_exists_description: "此使用者將使用現有的帳號資訊加入餐廳。",
      password_option: "密碼選項",
      set_password_now: "現在設定密碼",
      send_invite_email: "傳送邀請電子郵件",
      enter_password: "輸入密碼",
      password_min_length: "密碼至少需要 6 個字元",
      editing_roles_for: "編輯權限：",
      resetting_password_for: "重設密碼：",
      new_password: "新密碼",
      confirm_password: "確認密碼",
      please_enter_new_password: "請輸入新密碼",
      enter_new_password: "輸入新密碼",
      please_confirm_password: "請確認密碼",
      confirm_new_password: "確認新密碼",
      passwords_do_not_match: "密碼不相符",
      current_password: "目前密碼",
      please_enter_current_password: "請輸入目前密碼",
      enter_current_password: "輸入目前密碼",

      // Accept Invite Page
      set_your_password: "設定您的密碼",
      set_password_description: "建立密碼以完成帳號設定。",
      set_password: "設定密碼",
      password_set_successfully: "密碼設定成功",
      you_can_now_login: "您的密碼已設定完成，現在可以使用您的帳號登入。",
      go_to_login: "前往登入",
      invalid_invite_link: "無效的邀請連結",
      invalid_invite_link_description: "此邀請連結無效或已過期。請聯繫您的管理員取得新的邀請。",
      failed_to_accept_invite: "接受邀請失敗，請重試。",
      confirm_your_password: "確認您的密碼",

      // ===== COMBOS =====
      move_up: "上移",
      move_down: "下移",
      remove: "移除",
      combo_addons: "套餐加購",
      combo_addons_description:
        "可重複使用的套餐加購（例如飲料、配菜）。品項依價格分級，在套餐內以分級價格取代品項原價。",
      combo_add: "新增套餐",
      combo_badge: "套餐",
      combo_create: "建立套餐",
      combo_name: "套餐名稱",
      combo_basic_info: "套餐資訊",
      combo_chinese_name: "中文名稱",
      combo_spanish_name: "西班牙文名稱",
      combo_english_name: "英文名稱",
      combo_entrees: "主餐",
      combo_entrees_help: "顧客選擇一份主餐，以原價計算。",
      combo_needs_entree: "請至少新增一份主餐",
      combo_attach_addon: "加入加購項目",
      combo_create_new_addon: "建立新加購項目",
      combo_no_addons: "沒有加購項目",
      combo_no_addons_yet: "尚未加入加購項目，顧客只會選擇主餐。",
      combo_required: "必選",
      combo_required_for: "{{name}} 必選",
      combo_tiers_count: "價格分級（{{count}}）",
      combo_n_pts: "{{points}} 點",
      combo_pts: "點",
      combo_preview: "預覽",
      combo_preview_needs_entree: "新增主餐以查看價格。",
      combo_starting_price: "起始價格",
      combo_from_price: "{{price}} 起",
      combo_price_range: "價格範圍：{{min}} – {{max}}",
      combo_price_range_help: "從最便宜到最貴的組合，不含客製選項。",
      combo_from_points: "{{points}} 點起",
      combo_not_redeemable_with_points: "無法以點數兌換",
      combo_partly_redeemable_with_points: "部分選擇無法以點數兌換",
      combo_reason_entree_no_points: "{{name}} 沒有設定點數",
      combo_reason_tier_no_points: "{{addon}}（{{tier}}）沒有設定點數",
      combo_failed_to_load: "載入套餐失敗",
      combo_failed_to_save: "儲存套餐失敗",
      combo_delete_confirm: "確定刪除套餐 {{name}}？",
      combo_item_not_on_menu: "此品項不在此菜單上",
      combo_search_items: "搜尋要加入的品項",
      combo_items_selected: "已選 {{count}} 項",
      combo_no_items_found: "找不到品項",
      combo_create_addon: "建立加購項目",
      combo_edit_addon: "編輯加購項目",
      combo_addon_name_placeholder: "例如：飲料",
      combo_menu_type_locked: "此加購項目被以下套餐使用中，無法變更菜單類型：{{combos}}",
      combo_change_menu_type_title: "變更菜單類型？",
      combo_change_menu_type_content: "品項屬於特定菜單類型，所有分級中的品項都會被移除。",
      combo_tiers: "價格分級",
      combo_tiers_help: "每個分級中的品項共用一個價格。點數留空則使用餐廳預設的兌換比率。",
      combo_add_tier: "新增分級",
      combo_tier_default_name: "{{price}} 級",
      combo_tier_label: "分級名稱",
      combo_tier_price: "分級價格",
      combo_tier_points_help: "在套餐中以點數兌換此分級品項所需的點數",
      combo_points_default: "預設：{{points}} 點",
      combo_not_redeemable: "無法兌換",
      combo_duplicate_tier: "複製分級",
      combo_remove_tier: "移除分級",
      combo_copy_suffix: "（副本）",
      combo_tier_no_items: "尚無品項",
      combo_regular_price_in_combo: "原價 {{regular}} → 套餐內 {{combo}}",
      combo_move_to_tier: "移至分級",
      combo_tier_options_summary: "選項：{{summary}}",
      combo_tier_regular_option_prices: "原價",
      combo_option_free: "{{name}} 免費",
      combo_overridden_count: "已覆寫 {{count}} 項",
      combo_option_pricing: "選項價格",
      combo_option_pricing_help:
        "覆寫此加購項目中品項的選項價格。留空表示沿用：分級使用「所有分級」價格，否則使用原價。",
      combo_add_items_first: "請先在分級中加入品項，再設定選項價格。",
      combo_no_options_to_price: "此加購項目中的品項沒有選項。",
      combo_option_regular: "原價 {{price}}",
      combo_all_tiers: "所有分級",
      combo_all_tiers_override_for: "{{name}} 在所有分級的價格",
      combo_tier_override_for: "{{name}} 在 {{tier}} 的價格",
      combo_per_tier: "各分級（{{count}}）",
      combo_inherits: "沿用 {{price}}",
      combo_option_negative: "會使價格為負數（{{price}}）",
      combo_option_negative_tiers: "會使以下分級價格為負數：{{tiers}}",
      combo_fix_option_prices: "部分選項價格會使分級價格為負數。",
      combo_addon_needs_tier: "請至少新增一個分級",
      combo_tier_needs_item: "{{tier}} 至少需要一個品項",
      combo_failed_to_save_addon: "儲存加購項目失敗",
      combo_failed_to_load_addons: "載入加購項目失敗",
      combo_failed_to_delete_addon: "刪除加購項目失敗",
      combo_used_by: "使用中",
      combo_not_used: "未使用",
      combo_used_by_n_combos: "{{count}} 個套餐使用中",
      combo_addon_delete_in_use: "使用中無法刪除：{{combos}}",
      combo_delete_addon_confirm: "確定刪除加購項目 {{name}}？",
      delete_item_used_in_combos: "此品項用於套餐中：{{list}}。刪除後會從這些套餐中移除。",
      delete_item_combo_usage_entree: "{{name}}（主餐）",
      delete_item_combo_usage_tier: "{{addon}} 加購（{{tier}}）",
      delete_item_combo_usage_unknown: "無法確認此品項是否用於套餐中。",
    },
  },
  es: {
    translation: {
      // ===== COMMON / SHARED =====
      cancel: "Cancelar",
      clear: "Limpiar",
      done: "Terminado",
      submit: "Enviar",
      save: "Guardar",
      delete: "Eliminar",
      edit: "Editar",
      add: "Agregar",
      create: "Crear",
      search: "Buscar",
      filter: "Filtrar",
      export: "Exportar",
      import: "Importar",
      refresh: "Actualizar",
      back: "Volver",
      next: "Siguiente",
      previous: "Anterior",
      yes: "Sí",
      no: "No",
      ok: "Aceptar",
      min: "Mín",
      max: "Máx",
      success: "Éxito",
      error: "Error",
      warning: "Advertencia",
      info: "Información",
      loading: "Cargando",
      no_result: "Sin Resultados",
      try_searching_again: "Intenta buscar de nuevo",
      name: "Nombre",
      type: "Tipo",
      status: "Estado",
      actions: "Acciones",
      description: "Descripción",
      details: "Detalles",
      notes: "Notas",
      enabled: "Habilitado",
      true: "VERDADERO",
      false: "FALSO",
      na: "N/A",
      enter: "Entrar",
      select_quantity: "Seleccionar Cantidad",

      // ===== STATS / DATA VISUALIZATION =====
      show_table: "Mostrar Tabla",
      show_plot: "Mostrar Gráfico",
      error_loading_statistics: "Error al cargar estadísticas",
      please_adjust_date_range_and_retry:
        "Ajuste el rango de fechas si es necesario y haga clic en Buscar para intentarlo de nuevo.",
      retry: "Reintentar",

      // ===== NAVIGATION / HOME =====
      ticket_rails: "Ticket Rails",
      order_management_system: "Sistema de Gestión de Pedidos",
      workstations: "Estaciones de Trabajo",
      tools: "Herramientas",
      order_management: "Gestión de Pedidos",
      admin_functions: "Funciones de Administración",
      admin_dashboard: "Panel de Administración",
      admin_dashboard_description: "Acceso a todas las funciones y configuraciones de gestión",
      manager_functions: "Funciones de Gerente",
      manager_dashboard: "Panel de Gerente",
      manager_dashboard_description: "Ver estadísticas y gestionar códigos QR",
      welcome_manager_dashboard: "Bienvenido al Panel de Gerente",
      manager_dashboard_welcome_description:
        "Seleccione una función de la barra lateral o use las acciones rápidas a continuación",
      in_store_qr_code_description: "Generar y gestionar códigos QR para pedidos en tienda",

      // ===== ORDER MANAGEMENT =====
      master_control_station: "Estación de Control Principal",
      completed_orders: "Pedidos Completados",
      ready_for_pickup: "Listo para Recoger",
      sorted_by_done_time: "Ordenado por hora de finalización",
      online: "En Línea",
      in_store: "En Tienda",
      others: "Otros",
      order_lookup: "Búsqueda de Pedidos",
      order_time: "Hora del Pedido",
      start_time: "Hora de Inicio",
      done_time: "Hora de Finalización",
      paid: "PAGADO",
      not_paid: "NO PAGADO",
      no_results: "No se encontraron resultados",
      error_occurred: "Ocurrió un error",
      created_successfully: "{{item}} creado exitosamente",
      created_successfully_generic: "Creado exitosamente",
      updated_successfully: "{{item}} actualizado exitosamente",
      updated_successfully_generic: "Actualizado exitosamente",
      saved_successfully: "{{item}} guardado exitosamente",
      saved_successfully_generic: "Guardado exitosamente",
      deleted_successfully: "{{item}} eliminado exitosamente",
      order_date_optional: "Fecha del Pedido (Opcional, predeterminado: últimos 10 pedidos)",
      input_search_text: "Ingrese texto de búsqueda",
      back_to_search: "Volver a la búsqueda",
      search_for: "Buscado:",
      searching: "Buscando...",
      virtual_keyboard_hint: "Use el teclado en pantalla para ingresar su texto de búsqueda.",
      space: "Espacio",
      backspace: "Retroceso",
      phone: "Teléfono",
      email: "Correo Electrónico",
      immediate: "Inmediato",
      within_minutes: "Dentro de {{minutes}} Min",
      more_than_minutes: ">{{minutes}} Min",
      more_than_hours: ">{{hours}} Hrs",
      pickup_time: "Hora de Recogida",
      customer: "Cliente",
      item: "artículo",
      items: "artículos",
      unable_to_connect: "No se puede conectar",
      retrying: "Reintentando...",
      no_orders: "Sin pedidos",
      no_done_orders: "Sin pedidos completados",
      no_items: "Sin artículos",
      start_button: "Iniciar",
      done_button: "Completado",
      in_progress: "En Progreso",
      not_started: "No Iniciado",
      pending: "Pendiente",
      pending_orders: "Pendiente",
      started: "Iniciado",
      started_orders: "Iniciado",
      completed: "Completado",
      filter_by_item: "Filtrar por Artículo",
      order: "Pedido",
      create_time: "Hora de Creación",
      action: "Acción",
      shipping_label: "Etiqueta de Envío",
      packing_list: "Lista de Empaque",
      quantity: "Cant.",
      total_quantity: "Cantidad Total",
      customer_information: "Información del Cliente",
      address: "Dirección",
      pretax_price: "Precio sin Impuestos",
      handling_fee: "Tarifa de Manejo",
      failed_to_fetch_data: "No se pudieron obtener los datos",
      of: "de",
      order_incomplete_warning: "Este pedido parece incompleto. Clover podría tener un problema.",
      select_reminder_time: "Seleccionar hora de recordatorio",
      reminder_set: "Te recordaré a las {{time}}",
      remind_me: "Recuérdame",
      reminder_cancelled: "Recordatorio cancelado",
      cancel_reminder: "Cancelar Recordatorio",
      points_claimed: "Puntos reclamados",
      unable_to_print: "No se puede imprimir",
      unable_to_reprint_labels: "No se pueden reimprimir etiquetas",
      unable_to_print_points: "No se pueden imprimir puntos",
      print_points: "Imprimir Puntos",
      print: "Imprimir",
      print_order_ticket: "Imprimir Pedido",
      reprint_labels: "Reimprimir Etiquetas",
      print_beverage_labels: "Imprimir Etiquetas de Bebidas",
      print_non_beverage_labels: "Imprimir Etiquetas de Comida",
      auto_print_on_start: "Auto-imprimir Etiquetas al Iniciar",
      auto_print_off: "Auto-imprimir Desactivado",
      on: "SÍ",
      off: "NO",
      please_try_again_later: "Por favor intenta de nuevo más tarde",
      unable_to_fetch_tables: "No se pueden obtener mesas",
      unable_to_add_table: "No se puede agregar mesa",
      unable_to_fetch_order_history: "No se puede obtener el historial de pedidos",
      unable_to_fetch_points_history: "No se puede obtener el historial de puntos",
      sorry_error_occurred: "¡Lo sentimos, ocurrió un error!",
      reload: "Recargar",
      selected: "Seleccionado",

      // ===== WORKSTATION NAMES =====
      station: "Estación",
      workstation_fry: "Freidora",
      workstation_grill: "Parrilla",
      workstation_rice: "Arroz",
      workstation_assembly: "Ensamblaje",
      workstation_prep: "Preparación",

      // ===== ADMIN FUNCTIONS =====
      edit_menu: "Editar Menú",
      edit_menu_description: "Administrar los elementos del menú de su restaurante",
      edit_customization_options: "Editar Opciones de Personalización",
      announcement_settings: "Configuración de Anuncios",
      manage_members: "Gestionar Clientes",
      manage_members_description: "Ver y gestionar cuentas de clientes",
      statistics: "Estadísticas",
      statistics_description: "Ver análisis de rendimiento e información",
      reports: "Informes",
      in_store_qr_code: "Código QR en Tienda",
      shipping_orders: "Pedidos de Envío",
      shipping_orders_description: "Gestionar pedidos de entrega y envío",
      feature_flags: "Banderas de Funciones",
      printer_management: "Gestión de Impresoras",
      custom_order_page: "Página de Pedido Personalizado",
      menu_management: "Gestión de Menú",
      large_volume_management: "Gestión de pedidos de grupo",
      members_management: "Gestión de Clientes",
      orders_management: "Gestión de Pedidos",
      data_analytics: "Datos y Análisis",
      settings: "Configuración",
      back_to_home: "Volver a Inicio",
      welcome_admin_dashboard: "Bienvenido al Panel de Administración",
      admin_dashboard_welcome_description:
        "Seleccione una función en la barra lateral o use las acciones rápidas a continuación",
      quick_actions: "Acciones Rápidas",
      all_functions: "Todas las Funciones",
      search_by_name: "Búsqueda por nombre",

      // ===== LOGIN =====
      login: "Iniciar Sesión",
      account: "Cuenta",
      password: "Contraseña",
      please_enter_account: "Por favor ingrese la cuenta",
      please_enter_password: "Por favor ingrese la contraseña",
      required_to_login_with_admin_account:
        "Se requiere iniciar sesión con cuenta de administrador",
      no_restaurants_for_account: "No hay restaurantes para esta cuenta",
      failed_to_login: "Error al iniciar sesión",

      // ===== TRID CONVERTER =====
      trid_converter_title: "Conversor de TRID",
      trid_converter_description: "Convierta entre UUID e ID de TicketRails.",
      trid_converter_uuid_to_trid: "UUID a TRID",
      trid_converter_trid_to_uuid: "TRID a UUID",
      trid_converter_uuid: "UUID",
      trid_converter_trid: "TRID",
      trid_converter_tag: "Etiqueta",
      trid_converter_uuid_placeholder: "600f2814-c7d7-438c-b419-d813b15966aa",
      trid_converter_trid_placeholder: "its_YA8oFMfXQ4y0GdgTsVlmqg",
      trid_converter_tag_placeholder: "its",
      trid_converter_result_placeholder: "El valor convertido aparecerá aquí",
      trid_converter_tag_help: "Ingrese la etiqueta de recurso de tres letras.",
      trid_converter_invalid_uuid: "Ingrese un UUID válido.",
      trid_converter_invalid_tag: "La etiqueta debe tener exactamente tres letras minúsculas.",
      trid_converter_invalid_trid: "Ingrese un TRID válido.",
      trid_converter_invalid_trid_payload: "El TRID no contiene un UUID válido.",
      trid_converter_trid_result: "TRID convertido",
      trid_converter_uuid_result: "UUID convertido",
      trid_converter_tag_result: "Etiqueta TRID",
      trid_converter_copy_trid: "Copiar TRID",
      trid_converter_copy_uuid: "Copiar UUID",
      trid_converter_copied: "Copiado",
      trid_converter_local_only: "Todas las conversiones se realizan localmente en su navegador.",

      // ===== RESTAURANT SELECTION =====
      select_restaurant: "Seleccionar Restaurante",
      select_restaurant_description: "Elija qué restaurante gestionar",
      switch_restaurant: "Cambiar Restaurante",
      select: "Seleccionar",

      // ===== ITEM MODIFICATION SCHEMA =====
      add_customization_option: "Agregar Opción de Personalización",
      option_name: "Nombre de Opción",
      please_enter_option_name: "Por favor ingrese el nombre de la opción",
      allow_multiple_selection: "Permitir Selección Múltiple",
      optional: "Opcional",
      option_list: "Lista de Opciones",
      add_option: "Agregar Opción",
      price_adjustment: "Ajuste de Precio",
      default: "Predeterminado",
      edit_customization_option: "Editar Opción de Personalización",
      delete_customization_option_confirm: "¿Eliminar opción de personalización?",
      delete_customization_option_description:
        "Esta acción no se puede deshacer. Los artículos que usan esta opción se verán afectados.",

      // ===== MENU EDITOR =====
      menu_item_name: "Nombre del Elemento del Menú",
      receipt_name: "Nombre del Recibo",
      kitchen_chinese_name: "Nombre en Chino de la Cocina",
      kitchen_spanish_name: "Nombre en Español de la Cocina",
      kitchen_english_name: "Nombre en Inglés de la Cocina",
      key_example: "Clave (ej. R3, A4)",
      price: "Precio",
      points: "Puntos",
      points_config: "Configuración de Puntos",
      failed_to_fetch_points_config: "Error al obtener la configuración de puntos",
      failed_to_update_points_config: "Error al actualizar la configuración de puntos",
      use_automatic_redeem_rate: "Usar Tasa de Canje Automática",
      use_automatic_redeem_rate_description:
        "Cuando está activado, los artículos sin valor de puntos usan esta tasa (según el precio) para poder canjearse. Los artículos con un valor de puntos lo conservan.",
      redeem_rate: "Tasa de Canje",
      redeem_rate_description:
        "Puntos predeterminados por cada $1, usados solo para artículos sin valor de puntos. El precio se redondea hacia arriba al siguiente dólar.",
      redeem_rate_required_when_enabled:
        "Se requiere una tasa de canje cuando la tasa de canje automática está activada.",
      redeem_rate_must_be_positive: "La tasa de canje debe ser mayor que 0.",
      points_per_dollar: "puntos / $",
      redeem_rate_preview: "Un artículo de $10 sin puntos cuesta {{points}} puntos para canjear.",
      points_redeem_rate_fallback:
        "Déjelo en blanco para usar la tasa de canje ({{points}} pts para este precio).",
      wait_config: "Configuración de Tiempo de Espera",
      failed_to_fetch_wait_config: "Error al obtener la configuración del tiempo de espera",
      failed_to_update_wait_config: "Error al actualizar la configuración del tiempo de espera",
      wait_config_intro:
        "El tiempo de espera cotizado crece con la carga de la cocina, medida en puntos de preparación. Cada artículo aporta el peso de preparación de las estaciones que lo preparan (configurado en la página de estaciones de trabajo).",
      base_wait_minutes: "Espera Base",
      base_wait_minutes_description: "Espera mínima cotizada cuando la cocina está libre.",
      points_per_step: "Carga por Paso Adicional",
      points_per_step_description:
        "Carga de cocina (en puntos de preparación) que agrega un paso de espera adicional.",
      step_minutes: "Tamaño del Paso",
      step_minutes_description: "Minutos adicionales agregados por cada paso completo de carga.",
      max_wait_minutes: "Espera Máxima",
      max_wait_minutes_description:
        "Límite superior de la espera cotizada, sin importar la carga de la cocina.",
      large_order_points: "Umbral de Pedido Grande",
      large_order_points_description:
        "Los pedidos que superan estos puntos de preparación se consideran grandes: ven todo el trabajo pendiente de la cocina y no retrasan los pedidos pequeños.",
      minutes: "min",
      load_points: "puntos de preparación",
      wait_config_minutes_range: "Debe estar entre 1 y {{max}} minutos.",
      wait_config_step_minutes_range: "Debe estar entre 0 y {{max}} minutos.",
      wait_config_points_range: "Debe estar entre 1 y {{max}} puntos.",
      max_wait_must_be_gte_base: "La espera máxima no puede ser menor que la espera base.",
      wait_config_summary:
        "Las cotizaciones comienzan en {{base}} min y crecen {{step}} min por cada {{pointsPerStep}} puntos de carga de cocina, hasta {{max}} min. Los pedidos con más de {{largeOrderPoints}} puntos se consideran pedidos grandes.",
      prep_weight: "Peso de Preparación",
      prep_weight_description:
        "Puntos de carga de cocina agregados por cada acción de artículo en esta estación (p. ej. freír = 3, arroz = 1, ensamblaje = 0). Se usa para la estimación del tiempo de espera según la carga.",
      prep_weight_unit: "puntos / acción",
      prep_weight_range: "El peso de preparación debe estar entre 0 y {{max}}.",
      failed_to_update_prep_weight: "Error al actualizar el peso de preparación",
      tax_free: "Libre de Impuestos",
      shippable: "Enviable",
      weight_grams: "Peso (gramos)",
      print_label: "Imprimir Etiqueta",
      sold_out: "Agotado",
      featured: "Destacado",
      actions_workstation: "Acciones (Estación de Trabajo)",
      modifications_customization: "Modificaciones (Personalización)",
      upload_image: "Subir Imagen",
      saving: "Guardando...",
      name_is_required: "El nombre es obligatorio.",
      price_is_required: "El precio es obligatorio.",
      weight_is_required_for_shippable: "El peso es obligatorio para artículos enviables.",
      select_menu_type: "Seleccionar Tipo de Menú",
      dine_in_pickup: "Comer en / Recoger",
      group_order: "Pedido Grupal",
      notification_time_minutes: "Tiempo de Notificación (minutos)",
      limited_quantity: "Cantidad Limitada",
      quantity_limit: "Límite de Cantidad",
      quantity_limit_help: "Suministro total máximo. Dejar en blanco para ilimitado.",
      quantity_limit_placeholder: "Ilimitado",
      per_order_quantity_limit: "Límite por Pedido",
      per_order_quantity_limit_help: "Cantidad máxima por pedido. Dejar en blanco para ilimitado.",
      per_order_quantity_limit_placeholder: "Ilimitado",
      limited_quantity_inventory: "Inventario de Cantidad Limitada",
      consumption_trend: "Tendencia de Consumo",
      no_limited_quantity_items: "No hay artículos de cantidad limitada configurados.",
      select_item: "Seleccionar artículo",
      select_an_item_to_view_trend: "Seleccione un artículo para ver su tendencia de consumo.",
      no_trend_data: "Sin datos de consumo en el rango seleccionado.",
      consumed: "Consumido",
      reserved: "Reservado",
      remaining: "Restante",
      delete_menu_item_confirm: "¿Está seguro de que desea eliminar {{name}}?",
      delete_menu_item_description: "Esta acción no se puede deshacer.",
      create_item: "Crear Artículo",
      image: "Imagen",
      bulk_update_success: "¡{{count}} artículo(s) actualizado(s) con éxito!",
      bulk_update_partial_failure:
        "{{success}} de {{total}} artículos actualizados. {{failed}} fallaron.",

      // ===== MEMBERS =====
      email_or_phone: "Correo Electrónico o Teléfono",
      member_since: "Miembro Desde",
      order_history: "Historial de Pedidos",
      points_history: "Historial de Puntos",
      adjust_points: "Ajustar Puntos",
      search_member: "Buscar Miembro",
      member_information: "Información de Miembro",
      member_not_found: "Miembro no encontrado",
      unable_to_search_member: "No se puede buscar miembro",
      email_or_phone_is_required: "El correo electrónico o teléfono es obligatorio.",
      points_is_required: "Los puntos son obligatorios.",
      expiration: "Vencimiento",
      expiration_date_required_for_credits:
        "La fecha de vencimiento es obligatoria para agregar créditos.",
      manually_added_by_restaurant: "Agregado manualmente por el restaurante",
      added_points_successfully: "¡Se agregaron {{delta}} puntos exitosamente!",

      // ===== ANNOUNCEMENTS =====
      title: "Título",
      content: "Contenido",
      create_new_announcement: "Crear Nuevo Anuncio",
      current_announcements: "Anuncios Actuales",
      no_announcements: "Aún no hay anuncios",
      system_shutdown_control: "Control de Cierre del Sistema",
      title_is_required: "El título es obligatorio.",
      announcement_type_is_required: "El tipo de anuncio es obligatorio.",
      added_new_announcement_successfully: "¡Anuncio agregado exitosamente!",
      open_restaurant: "Abrir Restaurante",
      shutdown_restaurant: "Cerrar Restaurante",
      reopen: "Reabrir",
      temporarily_closed: "Cerrado Temporalmente",
      are_you_sure_reopen: "¿Está seguro de que desea reabrir el restaurante?",
      are_you_sure_shutdown: "¿Está seguro de que desea cerrar el restaurante?",
      restaurant_shutdown_successfully: "¡Restaurante cerrado exitosamente!",
      restaurant_reopened_successfully: "¡Restaurante reabierto exitosamente!",
      temporary_closure: "Cierre Temporal",
      sorry_temporarily_closed:
        "¡Lo sentimos! ¡Estamos temporalmente cerrados! Por favor vuelva más tarde.",

      // ===== FEATURE FLAGS =====
      flag_name: "Nombre de Bandera",
      enabled_is_required: "Habilitado es obligatorio.",
      updated_feature_flag_successfully: "¡Bandera de función actualizada exitosamente!",
      failed_to_save_feature_flag: "Error al guardar bandera de función",
      failed_to_fetch_flags: "Error al obtener banderas",
      update_flag: "Actualizar Bandera",
      current_flags: "Banderas Actuales",
      no_flags_available: "No hay banderas de funciones disponibles",
      flags: "banderas",

      // ===== PRINTER MANAGEMENT =====
      saved_printers: "Impresoras Guardadas",
      add_a_printer: "Agregar una Impresora",
      select_printer_type: "Seleccionar Tipo de Impresora",
      manage_connected_printers: "Gestionar sus impresoras conectadas",
      no_saved_printers: "Aún no hay impresoras guardadas",
      no_available_printers: "No hay impresoras disponibles",
      make_sure_printer_plugged_in: "Asegúrese de que la impresora esté encendida y conectada.",
      select_type_for_printer: "Seleccione el tipo para esta impresora",
      failed_to_load_connected_printers: "Error al cargar impresoras conectadas.",
      printer_added_successfully: "Impresora agregada exitosamente.",
      failed_to_add_printer: "Error al agregar impresora. Puede que ya esté conectada.",
      printer_deleted_successfully: "Impresora eliminada exitosamente.",
      failed_to_delete_printer: "Error al eliminar impresora.",
      serial: "Serial",
      vendor_id: "ID de Proveedor",
      product_id: "ID de Producto",
      add_a_usb_printer: "Agregar una impresora usb",
      add_a_network_printer: "Agregar una impresora de red",
      scan_for_new_printers: "Buscar nuevas impresoras",
      scanning_for_printers: "Buscando nuevas impresoras",
      this_will_take_around_10_seconds: "Esto tardará unos 10 segundos",
      printer_scan_complete: "Escaneo de la impresora completado",
      print_test_page: "Imprimir página de prueba",
      test_page_printed_successfully: "Página de prueba impresa exitosamente.",
      failed_to_print_test_page: "Error al imprimir la página de prueba.",
      only_one_printer_per_type: "Solo se puede guardar una impresora por tipo de impresora.",
      printer_type_already_added:
        "Ya hay una impresora {{type}} guardada. Elimine la impresora {{type}} existente antes de agregar una nueva.",
      printer_type_already_added_short: "ya agregada",
      all_printer_types_already_added:
        "Ya hay una impresora guardada para cada tipo. Elimine una antes de agregar otra.",

      // ===== WORKSTATION =====
      clear_all_items: "¿Limpiar todo?",

      // ===== QR CODES =====
      qr_code_management: "Gestión de Código QR",
      table_number: "Número de Mesa",
      generate_qr_code: "Generar Código QR",
      create_new_qr_code: "Crear Nuevo Código QR",
      current_qr_codes: "Códigos QR Actuales",
      no_qr_codes_message: "Aún no hay códigos QR. ¡Crea uno para empezar!",
      total_qr_codes: "Total {{total}} códigos QR",

      // ===== SHIPPING =====
      shipping_management: "Gestión de Envíos",
      shipping_orders_management: "Gestión de Pedidos de Envío",
      tracking_number: "Número de Seguimiento",
      shipping_address: "Dirección de Envío",
      order_status: "Estado del Pedido",

      // ===== STATS & REPORTS =====
      view_statistics: "Ver Estadísticas",
      generate_report: "Generar Informe",
      date_range: "Rango de Fechas",
      start_date: "Fecha de Inicio",
      end_date: "Fecha de Finalización",
      total_orders: "Total de Pedidos",
      total_revenue: "Ingresos Totales",
      average_order_value: "Valor Promedio del Pedido",
      select_month: "Seleccionar Mes",
      order_report: "Informe de Pedidos",
      current_month_to_date: "Mes actual hasta la fecha",

      // ===== CAMPAIGNS =====
      campaign_name: "Nombre de Campaña",
      campaigns: "Campañas",
      create_campaign: "Crear Campaña",
      copy_campaign: "Copiar Campaña",
      campaign_copy_prefix: "Copia de ",
      campaign_status: "Estado",
      campaign_status_past: "Pasada",
      campaign_status_active: "Activa",
      campaign_status_scheduled: "Programada",
      campaigns_load_failed: "No se pudieron cargar las campañas",
      campaign: "Campaña",
      campaign_pending: "{{name}} - pendiente",
      campaign_done: "{{name}} - terminado",
      no_campaigns: "No se encontraron campañas",
      campaign_export_paid_orders: "Exportar Pedidos Pagados",
      campaign_export_failed: "No se pudieron exportar los pedidos pagados",
      campaign_no_paid_orders: "Esta campaña aún no tiene pedidos pagados",
      campaign_summary_load_failed: "No se pudo cargar el resumen de la campaña",
      campaign_paid_orders: "Pedidos Pagados",
      campaign_item_name: "Artículo",
      campaign_item_modifications: "Modificaciones",
      not_available: "N/D",
      campaign_type: "Tipo de Campaña",
      campaign_basic_information: "Información Básica de Campaña",
      schedule_settings: "Configuración de Horarios",
      select_menu_items: "Seleccionar Elementos del Menú",
      slug: "Slug",
      ticket_prefix: "Prefijo de Ticket",
      order_deadline_date: "Fecha Límite de Pedido",
      order_deadline_time: "Hora Límite de Pedido",
      fulfillment_start_date: "Fecha de Inicio de Cumplimiento",
      fulfillment_end_date: "Fecha de Fin de Cumplimiento",
      fulfillment_date_range: "Rango de Fechas de Cumplimiento",
      fulfillment_time_start: "Hora de Inicio de Cumplimiento",
      fulfillment_time_end: "Hora de Fin de Cumplimiento",
      is_batch_delivery: "Es Entrega por Lotes",
      save_campaign: "Guardar Campaña",
      please_input_name: "Por favor ingrese el nombre",
      please_input_slug: "Por favor ingrese el slug",
      please_input_ticket_prefix: "Por favor ingrese el prefijo de ticket",
      please_select_date: "Por favor seleccione una fecha",
      please_select_time: "Por favor seleccione una hora",
      total_items_count: "Total {{total}} artículos",

      // ===== FORM VALIDATION =====
      this_field_is_required: "Este campo es obligatorio",
      please_enter_valid_email: "Por favor ingrese un correo electrónico válido",
      please_enter_valid_phone: "Por favor ingrese un número de teléfono válido",

      // ===== TOOLTIPS =====
      tooltip_back: "Volver al Inicio",
      tooltip_printer: "Gestión de Impresoras",
      tooltip_refresh: "Actualizar Página",
      tooltip_logout: "Cerrar Sesión",

      // ===== HEADER MENU =====
      language: "Idioma",
      logout: "Cerrar Sesión",
      choose_your_language: "Elige tu Idioma",
      language_preference_saved: "Su preferencia de idioma se guardará automáticamente",

      // ===== INTEGRATIONS =====
      integrations: "Integraciones",
      square_integrations: "Integraciones de Square",
      add_square_integration: "Agregar Integración de Square",
      current_integrations: "Integraciones Actuales",
      failed_to_fetch_integrations: "Error al obtener las integraciones",
      failed_to_create_integration: "Error al crear la integración",
      failed_to_delete_integration: "Error al eliminar la integración",
      delete_integration_confirm: "¿Está seguro de que desea eliminar esta integración?",
      delete_integration_description: "Esta acción no se puede deshacer.",
      no_integrations_available: "No hay integraciones disponibles",
      access_token: "Token de Acceso",
      access_token_required: "Se requiere el token de acceso",
      enter_access_token: "Ingrese el token de acceso",
      location_id: "LocationID",
      location_id_required: "Se requiere el LocationID",
      enter_location_id: "Ingrese el LocationID",
      tax_percentage: "Porcentaje de Impuestos",
      tax_percentage_tooltip: "El porcentaje de impuestos a aplicar en los pedidos en línea.",
      enter_tax_percentage: "Ingrese el porcentaje de impuestos",
      tax_percentage_required:
        "El porcentaje de impuestos es requerido cuando se usa para pago en línea",
      tax_percentage_invalid_format: "Por favor ingrese un número válido con hasta 5 decimales",
      edit_tax_percentage: "Editar % de Impuesto",
      enter_tax_percentage_6_decimals: "Ingrese un número decimal positivo con hasta 6 decimales.",
      tax_percentage_invalid_format_6_decimals:
        "Por favor ingrese un número positivo válido con hasta 6 decimales",
      tax_percentage_must_be_positive: "El porcentaje de impuestos debe ser un número positivo",
      failed_to_update_tax_percentage: "Error al actualizar el porcentaje de impuestos",
      use_for_online_payment: "Usar para Pagos en Línea",
      create_integration: "Crear Integración",
      merchant_id: "MerchantID",

      // ===== RESTAURANT PUBLIC INFO =====
      restaurant_public_info: "Información del Restaurante",
      failed_to_fetch_restaurant_public_info: "Error al obtener la información del restaurante",
      failed_to_update_restaurant_public_info: "Error al actualizar la información del restaurante",
      enter_address: "Ingrese la dirección",
      business_hours: "Horario de Atención",
      open_time: "Hora de Apertura",
      close_time: "Hora de Cierre",
      select_open_time: "Seleccione la hora de apertura",
      select_close_time: "Seleccione la hora de cierre",
      social_media_links: "Enlaces de Redes Sociales",
      instagram_url: "URL de Instagram",
      google_url: "URL de Google",
      yelp_url: "URL de Yelp",
      facebook_url: "URL de Facebook",
      enter_instagram_url: "Ingrese la URL de Instagram",
      enter_google_url: "Ingrese la URL de Google",
      enter_yelp_url: "Ingrese la URL de Yelp",
      enter_facebook_url: "Ingrese la URL de Facebook",
      ordering_links: "Enlaces de Pedidos",
      order_url: "URL de Pedidos",
      order_url_help:
        "URL del sitio de pedidos cuando es gestionado por nosotros. Dejar en blanco si no aplica.",
      enter_order_url: "Ingrese la URL de pedidos",
      delivery_url: "URL de Entrega",
      delivery_url_help:
        "URL de pedidos de entrega de terceros (ej. DoorDash). Dejar en blanco si no se ofrece entrega.",
      enter_delivery_url: "Ingrese la URL de entrega",
      public_listing: "Listado Público",
      listed: "Listado",
      listed_help:
        "Si este restaurante aparece en el listado público de ubicaciones en el sitio de pedidos.",
      coming_soon: "Próximamente",
      coming_soon_help:
        'Una ubicación listada que aún no está abierta: se muestra en el sitio de pedidos con su información y un tratamiento de "Próximamente", pero no se pueden hacer pedidos.',
      coming_soon_requires_listed:
        "La ubicación debe estar listada para marcarla como próximamente.",
      default_tip_percentages: "Porcentajes de Propina Predeterminados",
      tip_option_1: "Opción de Propina 1",
      tip_option_2: "Opción de Propina 2",
      tip_option_3: "Opción de Propina 3",

      promo_codes: "Códigos Promocionales",
      promo_code: "Código Promocional",
      create_promo_code: "Crear Código Promocional",
      no_promo_codes_available: "No hay códigos promocionales disponibles",
      failed_to_fetch_promo_codes: "Error al obtener códigos promocionales",
      failed_to_create_promo_code: "Error al crear código promocional",
      failed_to_update_promo_code: "Error al actualizar código promocional",
      failed_to_fetch_item_schemas: "Error al obtener los artículos",
      promo_slug: "Código",
      slug_is_required: "El código es obligatorio",
      slug_max_length: "El código debe tener máximo 100 caracteres",
      slug_placeholder: "ej. SAVE10",
      promo_description: "Descripción",
      description_placeholder: "Descripción opcional para el administrador",
      promo_discount: "Descuento",
      discount_type: "Tipo de Descuento",
      percent_of_order_total: "Porcentaje del Total del Pedido",
      fixed_amount: "Monto Fijo",
      discount_percent: "Porcentaje de Descuento",
      discount_amount: "Monto de Descuento",
      discount_value_is_required: "El valor de descuento es obligatorio",
      discount_percent_range: "El porcentaje debe estar entre 1 y 100",
      discount_amount_positive: "El monto debe ser positivo",
      promo_expire_time: "Fecha de Expiración",
      expire_time_is_required: "La fecha de expiración es obligatoria",
      edit_expire_time: "Editar Fecha de Expiración",
      expired: "Expirado",
      promo_conditions: "Condiciones",
      promo_min_spend: "Gasto Mínimo",
      min_spend_conditions: "Condiciones de Gasto Mínimo",
      min_spend_is_required: "El gasto mínimo es obligatorio",
      add_min_spend_condition: "Agregar Condición de Gasto Mínimo",
      item_conditions: "Condiciones de Artículo",
      promo_item: "Artículo",
      item_is_required: "El artículo es obligatorio",
      quantity_is_required: "La cantidad es obligatoria",
      promo_select_item: "Seleccionar un artículo",
      add_item_condition: "Agregar Condición de Artículo",
      promo_code_condition_required_notice:
        "Se requiere al menos una condición (gasto mínimo o artículo).",
      counts_towards_min_spend: "Cuenta hacia gasto mínimo",
      excludes_from_min_spend: "Excluye del gasto mínimo",
      promo_item_excludes_min_spend: "excluye gasto mínimo",
      promo_item_min_spend_help:
        "Cuando está apagado, la cantidad requerida de este artículo no cuenta hacia el gasto mínimo.",

      // ===== PREPAID CARDS =====
      view: "Ver",
      publish: "Publicar",
      archive: "Archivar",
      close: "Cerrar",
      exclusive_end: "exclusivo",
      day_sun: "Domingo",
      day_mon: "Lunes",
      day_tue: "Martes",
      day_wed: "Miércoles",
      day_thu: "Jueves",
      day_fri: "Viernes",
      day_sat: "Sábado",
      day_sun_abbr: "Dom",
      day_mon_abbr: "Lun",
      day_tue_abbr: "Mar",
      day_wed_abbr: "Mié",
      day_thu_abbr: "Jue",
      day_fri_abbr: "Vie",
      day_sat_abbr: "Sáb",

      prepaid_cards: "Tarjetas Prepagadas",
      prepaid_card: "Tarjeta Prepagada",
      prepaid_card_stats: "Estadísticas de Tarjetas Prepagadas",
      prepaid_card_create: "Crear Tarjeta Prepagada",
      prepaid_card_edit: "Editar Tarjeta Prepagada",
      prepaid_card_view: "Ver Tarjeta Prepagada",
      prepaid_card_none_available: "No hay tarjetas prepagadas disponibles",
      failed_to_fetch_prepaid_cards: "Error al obtener las tarjetas prepagadas",
      failed_to_create_prepaid_card: "Error al crear la tarjeta prepagada",
      failed_to_update_prepaid_card: "Error al actualizar la tarjeta prepagada",
      failed_to_publish_prepaid_card: "Error al publicar la tarjeta prepagada",
      failed_to_archive_prepaid_card: "Error al archivar la tarjeta prepagada",
      failed_to_delete_prepaid_card: "Error al eliminar la tarjeta prepagada",
      prepaid_card_published_successfully: "Tarjeta prepagada publicada correctamente",
      prepaid_card_archived_successfully: "Tarjeta prepagada archivada correctamente",
      prepaid_card_deleted_successfully: "Tarjeta prepagada eliminada correctamente",
      prepaid_card_price: "Precio",
      prepaid_card_price_is_required: "El precio es obligatorio",
      prepaid_card_price_positive: "El precio debe ser positivo",
      prepaid_card_redeem_count: "Número de Canjes",
      prepaid_card_redeem_count_is_required: "El número de canjes es obligatorio",
      prepaid_card_redeem_count_positive: "El número de canjes debe ser positivo",
      prepaid_card_redeems_lowercase: "canjes",
      prepaid_card_tax_free: "Libre de Impuestos",
      prepaid_card_supported_items: "Artículos Compatibles",
      prepaid_card_supported_items_required: "Se requiere al menos un artículo compatible",
      prepaid_card_select_items: "Seleccionar artículos compatibles",
      prepaid_card_redeem_window: "Período de Canje",
      prepaid_card_redeem_window_required: "El período de canje es obligatorio",
      prepaid_card_redeem_window_help: "La fecha final es exclusiva.",
      prepaid_card_redeem_days: "Días Canjeables",
      prepaid_card_redeem_days_required: "Se requiere al menos un día canjeable",
      prepaid_card_purchase_window: "Período de Venta",
      prepaid_card_purchase_window_required: "El período de venta es obligatorio",
      prepaid_card_image: "Imagen",
      prepaid_card_name_placeholder: "ej. 10 Bentos de Almuerzo",
      prepaid_card_published_readonly_notice:
        "Esta tarjeta prepagada está publicada y ya no se puede editar. Aún puede archivarla para detener nuevas ventas.",
      prepaid_card_publish_confirm_title: '¿Publicar "{{name}}"?',
      prepaid_card_publish_warning:
        "Una vez publicada, esta tarjeta prepagada ya no se puede cambiar: el precio, el número de canjes, los artículos compatibles y ambos períodos de fecha quedan definitivos, porque los clientes comprarán bajo estos términos. Aún puede archivarla para detener nuevas ventas.",
      prepaid_card_archive_confirm_title: '¿Archivar "{{name}}"?',
      prepaid_card_archive_confirm_body:
        "Archivar oculta esta tarjeta de las nuevas ventas. Las tarjetas ya compradas siguen funcionando.",
      prepaid_card_delete_confirm_title: '¿Eliminar "{{name}}"?',
      prepaid_card_delete_confirm_body:
        "Esta tarjeta prepagada en borrador se eliminará permanentemente.",
      prepaid_card_delete_disabled_sold:
        "No se puede eliminar: esta tarjeta ya tiene ventas registradas",
      prepaid_card_cards_sold: "Tarjetas Vendidas",
      prepaid_card_cards_pending_payment: "Pendiente de Pago",
      prepaid_card_gross_revenue: "Ingresos Brutos",
      prepaid_card_counts_sold: "Canjes Vendidos",
      prepaid_card_counts_redeemed: "Canjes Realizados",
      prepaid_card_counts_reserved: "Canjes Reservados",
      prepaid_card_outstanding_redeems: "Canjes Pendientes",
      prepaid_card_expired_redeems: "Expirados",
      prepaid_card_liability: "Pasivo",
      prepaid_card_total_outstanding_redeems: "Total de Canjes Pendientes",
      prepaid_card_total_outstanding_liability: "Pasivo Total Pendiente",
      prepaid_card_no_stats_available: "No hay estadísticas de tarjetas prepagadas disponibles",
      prepaid_card_supported_items_unavailable: "Artículos compatibles no disponibles",
      prepaid_card_status_draft: "Borrador",
      prepaid_card_status_scheduled: "Programada",
      prepaid_card_status_live: "En Venta",
      prepaid_card_status_ended: "Finalizada",
      prepaid_card_status_archived: "Archivada",

      // ===== POINT GIFT CARDS =====
      point_gift_cards: "Tarjetas de Regalo de Puntos",
      point_gift_card: "Tarjeta de Regalo de Puntos",
      add_point_gift_card: "Agregar Tarjeta de Regalo de Puntos",
      current_gift_cards: "Tarjetas de Regalo Actuales",
      no_gift_cards_available: "No hay tarjetas de regalo disponibles",
      no_gift_cards_match_search: "No hay tarjetas de regalo que coincidan con su búsqueda",
      failed_to_fetch_gift_cards: "Error al obtener las tarjetas de regalo",
      failed_to_create_gift_card: "Error al crear la tarjeta de regalo",
      failed_to_delete_gift_card: "Error al eliminar la tarjeta de regalo",
      failed_to_download_qr_code: "Error al descargar el código QR",
      download_qr_code: "Descargar código QR (PNG)",
      download_sign: "Descargar cartel imprimible (PDF)",
      download_all_signs: "Descargar todos los carteles",
      download_selected_signs: "Descargar seleccionados ({{count}})",
      failed_to_download_sign: "Error al descargar el cartel",
      order_type: "Tipo de pedido",
      dine_in: "Comer aquí",
      to_go: "Para llevar",
      order_type_is_required: "El tipo de pedido es obligatorio.",
      added_new_table_successfully: "¡Mesa añadida con éxito!",
      delete_table_confirm: "¿Eliminar {{name}}?",
      preview_sign: "Vista previa del cartel",
      delete_gift_card_confirm: "¿Está seguro de que desea eliminar esta tarjeta de regalo?",
      delete_gift_card_description: "Esta acción no se puede deshacer.",
      cannot_delete_claimed_card: "No se puede eliminar una tarjeta de regalo reclamada",
      create_gift_card: "Crear Tarjeta de Regalo",
      gift_cards: "tarjetas de regalo",
      description_is_required: "La descripción es obligatoria",
      enter_description: "Ingrese la descripción",
      amount_is_required: "El monto es obligatorio",
      amount_must_be_greater_than_zero: "El monto debe ser mayor que 0",
      enter_amount: "Ingrese el monto",
      expiry_date: "Fecha de Vencimiento",
      expiry_date_tooltip: "Opcional. Deje vacío para sin vencimiento.",
      select_expiry_date: "Seleccione la fecha de vencimiento",
      claimed: "Reclamado",
      qr_code: "Código QR",
      search_by_amount_or_description: "Buscar por monto o descripción",

      // ===== WORKSTATION SCHEMAS =====
      workstation_schemas: "Estaciones de Trabajo",
      workstation_schema: "Estación de Trabajo",
      add_workstation_schema: "Agregar Estación de Trabajo",
      edit_workstation_schema: "Editar Estación de Trabajo",
      current_workstation_schemas: "Estaciones de Trabajo Actuales",
      no_workstation_schemas_available: "No hay estaciones de trabajo disponibles",
      failed_to_fetch_workstation_schemas: "Error al obtener las estaciones de trabajo",
      failed_to_create_workstation_schema: "Error al crear la estación de trabajo",
      failed_to_update_workstation_schema: "Error al actualizar la estación de trabajo",
      failed_to_delete_workstation_schema: "Error al eliminar la estación de trabajo",
      delete_workstation_schema_confirm:
        "¿Está seguro de que desea eliminar esta estación de trabajo?",
      delete_workstation_schema_description: "Esta acción no se puede deshacer.",
      enter_workstation_name: "Ingrese el nombre de la estación de trabajo",

      // ===== USER MANAGEMENT =====
      user_management: "Gestión de Usuarios",
      add_user: "Agregar Usuario",
      edit_roles: "Editar Roles",
      reset_password: "Restablecer Contraseña",
      change_password: "Cambiar Contraseña",
      send_invite: "Enviar Invitación",
      remove_user: "Eliminar Usuario",
      no_users_available: "No hay usuarios disponibles",
      failed_to_fetch_users: "Error al obtener usuarios",
      failed_to_create_user: "Error al crear usuario",
      failed_to_update_roles: "Error al actualizar roles",
      failed_to_reset_password: "Error al restablecer contraseña",
      failed_to_change_password: "Error al cambiar contraseña",
      failed_to_remove_user: "Error al eliminar usuario",
      failed_to_send_invite: "Error al enviar invitación",
      user_created_successfully: "Usuario creado exitosamente",
      user_created_send_invite_hint:
        "Usuario creado. Use 'Enviar Invitación' para configurar su contraseña.",
      user_added_to_restaurant: "Usuario agregado al restaurante",
      user_removed_successfully: "Usuario eliminado exitosamente",
      roles_updated_successfully: "Roles actualizados exitosamente",
      password_reset_successfully: "Contraseña restablecida exitosamente",
      password_changed_successfully: "Contraseña cambiada exitosamente",
      password_changed_please_login:
        "Contraseña cambiada exitosamente. Por favor inicie sesión nuevamente.",
      invite_sent_successfully: "Invitación enviada exitosamente",
      remove_user_confirm: "¿Eliminar este usuario?",
      remove_user_description: "El usuario ya no tendrá acceso a este restaurante.",
      cannot_remove_yourself: "No puede eliminarse a sí mismo",
      cannot_modify_admin: "No puede modificar a otro administrador",
      you: "Usted",
      roles: "Roles",
      role: "Rol",
      role_admin: "Administrador",
      role_manager: "Gerente",
      role_regular_user: "Usuario Regular (sin acceso especial)",
      roles_help: "Dejar vacío para acceso de usuario regular",
      please_select_roles: "Por favor seleccione al menos un rol",
      please_enter_email: "Por favor ingrese el correo electrónico",
      enter_email: "Ingrese el correo electrónico",
      user_exists_info: "El usuario ya existe",
      user_exists_description:
        "Este usuario será agregado al restaurante con sus credenciales existentes.",
      password_option: "Opción de Contraseña",
      set_password_now: "Establecer contraseña ahora",
      send_invite_email: "Enviar correo de invitación",
      enter_password: "Ingrese la contraseña",
      password_min_length: "La contraseña debe tener al menos 6 caracteres",
      editing_roles_for: "Editando roles para:",
      resetting_password_for: "Restableciendo contraseña para:",
      new_password: "Nueva Contraseña",
      confirm_password: "Confirmar Contraseña",
      please_enter_new_password: "Por favor ingrese la nueva contraseña",
      enter_new_password: "Ingrese la nueva contraseña",
      please_confirm_password: "Por favor confirme la contraseña",
      confirm_new_password: "Confirme la nueva contraseña",
      passwords_do_not_match: "Las contraseñas no coinciden",
      current_password: "Contraseña Actual",
      please_enter_current_password: "Por favor ingrese la contraseña actual",
      enter_current_password: "Ingrese la contraseña actual",

      // Accept Invite Page
      set_your_password: "Establezca Su Contraseña",
      set_password_description: "Cree una contraseña para completar la configuración de su cuenta.",
      set_password: "Establecer Contraseña",
      password_set_successfully: "Contraseña Establecida Exitosamente",
      you_can_now_login:
        "Su contraseña ha sido establecida. Ahora puede iniciar sesión con sus credenciales.",
      go_to_login: "Ir a Iniciar Sesión",
      invalid_invite_link: "Enlace de Invitación Inválido",
      invalid_invite_link_description:
        "Este enlace de invitación es inválido o ha expirado. Por favor contacte a su administrador para obtener una nueva invitación.",
      failed_to_accept_invite: "Error al aceptar la invitación. Por favor intente de nuevo.",
      confirm_your_password: "Confirme su contraseña",

      // ===== COMBOS =====
      menu_type: "Tipo de menú",
      reset: "Restablecer",
      move_up: "Mover arriba",
      move_down: "Mover abajo",
      remove: "Quitar",
      combo_addons: "Complementos de combo",
      combo_addons_description:
        "Complementos reutilizables (p. ej. bebidas, acompañantes) que ofrecen los combos. Los artículos se agrupan en niveles de precio; el precio del nivel reemplaza el precio normal del artículo dentro de un combo.",
      combo_add: "Agregar combo",
      combo_badge: "Combo",
      combo_create: "Crear combo",
      combo_name: "Nombre del combo",
      combo_basic_info: "Detalles del combo",
      combo_chinese_name: "Nombre en chino",
      combo_spanish_name: "Nombre en español",
      combo_english_name: "Nombre en inglés",
      combo_entrees: "Platos principales",
      combo_entrees_help: "El cliente elige un plato principal, a su precio normal.",
      combo_needs_entree: "Agregue al menos un plato principal",
      combo_attach_addon: "Adjuntar un complemento",
      combo_create_new_addon: "Crear nuevo complemento",
      combo_no_addons: "Sin complementos",
      combo_no_addons_yet:
        "No hay complementos adjuntos. Los clientes solo elegirán un plato principal.",
      combo_required: "Obligatorio",
      combo_required_for: "{{name}} obligatorio",
      combo_tiers_count: "Niveles ({{count}})",
      combo_n_pts: "{{points}} pts",
      combo_pts: "pts",
      combo_preview: "Vista previa",
      combo_preview_needs_entree: "Agregue un plato principal para ver el precio.",
      combo_starting_price: "Precio inicial",
      combo_from_price: "Desde {{price}}",
      combo_price_range: "Rango de precios: {{min}} – {{max}}",
      combo_price_range_help: "De la combinación más barata a la más cara, sin opciones.",
      combo_from_points: "Desde {{points}} pts",
      combo_not_redeemable_with_points: "No se puede canjear con puntos",
      combo_partly_redeemable_with_points: "Algunas opciones no se pueden canjear con puntos",
      combo_reason_entree_no_points: "{{name}} no tiene puntos",
      combo_reason_tier_no_points: "{{addon}} ({{tier}}) no tiene puntos",
      combo_failed_to_load: "Error al cargar los combos",
      combo_failed_to_save: "Error al guardar el combo",
      combo_delete_confirm: "¿Eliminar el combo {{name}}?",
      combo_item_not_on_menu: "Artículo no está en este menú",
      combo_search_items: "Buscar artículos para agregar",
      combo_items_selected: "{{count}} seleccionados",
      combo_no_items_found: "No se encontraron artículos",
      combo_create_addon: "Crear complemento",
      combo_edit_addon: "Editar complemento",
      combo_addon_name_placeholder: "p. ej. Bebidas",
      combo_menu_type_locked: "No se puede cambiar el tipo de menú mientras lo usan: {{combos}}",
      combo_change_menu_type_title: "¿Cambiar el tipo de menú?",
      combo_change_menu_type_content:
        "Los artículos pertenecen a un tipo de menú, por lo que se quitarán todos los artículos de los niveles.",
      combo_tiers: "Niveles",
      combo_tiers_help:
        "Cada nivel tiene un precio para todos sus artículos. Deje los puntos en blanco para usar la tasa de canje predeterminada del restaurante.",
      combo_add_tier: "Agregar nivel",
      combo_tier_default_name: "Nivel {{price}}",
      combo_tier_label: "Nombre del nivel",
      combo_tier_price: "Precio del nivel",
      combo_tier_points_help: "Puntos para canjear un artículo de este nivel en un combo",
      combo_points_default: "Predeterminado: {{points}} pts",
      combo_not_redeemable: "No canjeable",
      combo_duplicate_tier: "Duplicar nivel",
      combo_remove_tier: "Quitar nivel",
      combo_copy_suffix: " (copia)",
      combo_tier_no_items: "Aún no hay artículos",
      combo_regular_price_in_combo: "normal {{regular}} → {{combo}} en combo",
      combo_move_to_tier: "Mover a nivel",
      combo_tier_options_summary: "Opciones: {{summary}}",
      combo_tier_regular_option_prices: "precios normales",
      combo_option_free: "{{name}} gratis",
      combo_overridden_count: "{{count}} reemplazados",
      combo_option_pricing: "Precios de opciones",
      combo_option_pricing_help:
        "Reemplace los precios de opciones de los artículos de este complemento. En blanco significa heredar: un nivel usa el precio de Todos los niveles; si no, el precio normal.",
      combo_add_items_first:
        "Agregue artículos a los niveles para fijar el precio de sus opciones.",
      combo_no_options_to_price: "Los artículos de este complemento no tienen opciones.",
      combo_option_regular: "normal {{price}}",
      combo_all_tiers: "Todos los niveles",
      combo_all_tiers_override_for: "Precio de {{name}} en todos los niveles",
      combo_tier_override_for: "Precio de {{name}} en {{tier}}",
      combo_per_tier: "Por nivel ({{count}})",
      combo_inherits: "hereda {{price}}",
      combo_option_negative: "Hace que el precio sea negativo ({{price}})",
      combo_option_negative_tiers: "Hace que el precio sea negativo en: {{tiers}}",
      combo_fix_option_prices: "Algunos precios de opciones harían negativo el precio de un nivel.",
      combo_addon_needs_tier: "Agregue al menos un nivel",
      combo_tier_needs_item: "{{tier}} necesita al menos un artículo",
      combo_failed_to_save_addon: "Error al guardar el complemento",
      combo_failed_to_load_addons: "Error al cargar los complementos",
      combo_failed_to_delete_addon: "Error al eliminar el complemento",
      combo_used_by: "Usado por",
      combo_not_used: "Sin usar",
      combo_used_by_n_combos: "Usado por {{count}} combos",
      combo_used_by_n_combos_one: "Usado por {{count}} combo",
      combo_used_by_n_combos_other: "Usado por {{count}} combos",
      combo_addon_delete_in_use: "No se puede eliminar mientras lo usan: {{combos}}",
      combo_delete_addon_confirm: "¿Eliminar el complemento {{name}}?",
      delete_item_used_in_combos:
        "Este artículo se usa en combos: {{list}}. Al eliminarlo se quitará de ellos.",
      delete_item_combo_usage_entree: "{{name}} (plato principal)",
      delete_item_combo_usage_tier: "complemento {{addon}} ({{tier}})",
      delete_item_combo_usage_unknown: "No se pudo comprobar si este artículo se usa en combos.",
    },
  },
};

// Get saved language preference or default to "zh"
const savedLanguage = localStorage.getItem("user_pref:lang") || "zh";

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: "en",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
